import React, { useEffect, useRef, useState, useMemo } from "react";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import "./Jobs.css";
// import http from "./http-common";
import axios from "axios";

import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import GetAppIcon from "@mui/icons-material/GetApp";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Popper from "@mui/material/Popper";
import TextField from "@mui/material/TextField";
import MenuIcon from "@mui/icons-material/Menu";
import BarChartIcon from "@mui/icons-material/BarChart";
import ListIcon from "@mui/icons-material/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import DeleteForever from "@mui/icons-material/DeleteForever";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import SendIcon from "@mui/icons-material/Send";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MarkChatReadIcon from "@mui/icons-material/MarkChatRead";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import SummarizeIcon from "@mui/icons-material/Summarize";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ProfileIcon from "@mui/icons-material/AccountCircle";
import ErrorIcon from "@mui/icons-material/Error";
import FilterListIcon from '@mui/icons-material/FilterList';


import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

import { inferURLs, apiURLs, ohifURLs } from "./config";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";

import { onLogout } from "./Login";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RefreshIcon from "@mui/icons-material/Refresh";
import CommentIcon from "@mui/icons-material/Comment";

import { Select, MenuItem, ListSubheader, InputAdornment } from "@mui/material";

import logo from "./CARDIOLOGIQ_logo_cropped.png";
import { getRandomColor, createImageFromInitials } from "./utils/Utils";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LockResetIcon from "@mui/icons-material/LockReset";
import Notifications from "./utils/notifications";

import { DropzoneDialogBase } from "material-ui-dropzone";

import io from "socket.io-client";

import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CircleNotificationsRoundedIcon from "@mui/icons-material/CircleNotificationsRounded";
import Close from "@mui/icons-material/Close";

import NoteAdd from "@mui/icons-material/NoteAdd";
import useSound from "use-sound";

import boopSfx from "./assets/notetone.mp3";

import NewReleasesIcon from '@mui/icons-material/NewReleases';
import VerifiedIcon from '@mui/icons-material/Verified';

import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import { Document, Page, pdfjs } from "react-pdf";
import { CheckCircleOutline } from "@material-ui/icons";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  pt: 2,
  px: 4,
  pb: 3,
};

const styles = {
  wrapper: {
    width: "100%",
    height: "100%",
    // margin: '10px',
    // padding: '20px',
    background: "#fff",
    color: "black",
    overflow: "scroll",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    background: "#089AAC",// #1b4a92 design
    height: "40px",
    alignItems: "center",
    padding: "5px",
    color: "#fff",
  },
  dashboardWrapper: {
    // height: '100%',
    display: "flex",
    flexDirection: "row",
  },
  dashboardSelect: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#fff",
    fontFamily: "monospace",
    height: "40px",
    padding: "0px",
    margin: "0px",
  },
  dashboardHeaderText: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#fff",
    fontFamily: "Times New Roman",
  },
  menuButtonWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginRight: "20px",
  },
  menuButton: {
    cursor: "pointer",
  },
  logoutButton: {
    color: "#fff",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  drawer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 20px",
    width: "220px",
    height: "calc(100vh - 50px)",
    top: "50px",
    justifyContent: "flex-start",
    // background: 'red',
    background: "#fffeff",
    position: "absolute",
    zIndex: "1",
    boxShadow: "0px 3px 10px 1px rgba(0,0,0,0.75)",
    transition: "width 0.25s ease",
  },
  closedDrawer: {
    position: "absolute",
    width: "0px",
    height: "calc(100vh - 50px)",
    top: "50px",
    // background: 'red',
    zIndex: "-1",
    transition: "all 0.25s",
  },
  drawerContent: {
    marginTop: "20px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    background: "#fff",
    color: "#111",
    height: "100vh",
    width: "100%",
    // padding: '20px',
  },
  logoutWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    // minWidth: '100px',
    marginRight: "20px",
    gap: "20px",
  },
  statusWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // justifyContent: 'space-between',
  },
  statusObjAdmin: (status) => ({
    borderRadius: "6px",
    width: "12px",
    height: "12px",
    background:
      status === "Failed" ? "red" : status === "Finished" ? "green" : "#528398",
    marginRight: "4px",
  }),
  statusObj: (status) => ({
    borderRadius: "6px",
    width: "12px",
    height: "12px",
    background:
      status === "Failed"
        ? "red"
        : status === "completed"
        ? "green"
        : status === "verified"
        ? "#e8ff00" // yellow 
        : status === "rejected"
        ? "#f78629" // Red for rejected
        : status === "accepted"
        ? "#00ff3c" // Green for accepted
        : "#528398",
    marginRight: "4px",
  }),
  smallWidth: {
    maxWidth: "60px",
  },
  tableHeaderItem: {
    // color: '#049c77',
    textAlign: "center",
    verticalAlign: "middle",
    color: "#fff",
    border: "none",
    padding: "5px",
  },
  table: (pageHeight) => ({
    // borderRadius: '20px important!',
    border: "1px solid #111",
    // color: 'black',
    background: "#fff",
    color: "#111",
    // margin: '10px',
    marginBottom: pageHeight > 800 ? "10px" : "70px",
    fontWeight: "600",
    // width: '95%',
    // overflow: 'scroll',
    boxShadow: "0px 0px 10px 0px #000000",
  }),
  tableRow: (status, findings) => {
    return {
      background:
        status === "Finished"
          ? findings === true
            ? "#ffcccb" // Light red for finished with findings
            : "#aaeecc" // Light green for finished without findings
          : "#E0E0E0", // Light grey for other statuses
      color: "#111",
      fontWeight: "600",
      height: "30px",
      borderTop: "1px solid #0a0a12",
    };
  },
  
  tableBodyItem: {
    textAlign: "center",
    verticalAlign: "middle",
    maxHeight: "30px",
    borderWidth: "0px",
    borderStyle: "none",
    padding: "3px",
  },
  tableBodyItemMobile: {
    textAlign: "center",
    verticalAlign: "middle",
    height:"18.4px",
    with: "70vw"
  },
  modal: {
    background: "white",
    borderRadius: "5px",
    width: "600px",
    height: "400px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalMobile: {
    background: "white",
    borderRadius: "5px",
    width: "80%",
    height: "50%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sequencesModal: {
    background: "white",
    borderRadius: "5px",
    width: "60vw",
    height: "90vh",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-around",
    alignItems: "center",
  },
  sequencesModalMobile: {
    background: "white",
    borderRadius: "5px",
    width: "70vw",
    height: "60vh",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "7px",
    justifyContent: "center",
    alignItems: "center",
  },
  sequencesModalRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "95%",
  },
  select: {
    width: "400px",
    height: "40px",
    fontSize: "20px",
    fontWeight: "700",
    background: "#fff",
    color: "#000",
  },
  selectMobile: {
    width: "70%",
    minWidth:"30%",
    height: "26px",
    fontSize: "12px",
    fontWeight: "700",
    background: "#fff",
    color: "#000",
  },
  deleteModal: {
    background: "white",
    borderRadius: "5px",
    width: "450px",
    height: "300px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deleteModalMobile: {
    background: "white",
    borderRadius: "5px",
    width: "80%",
    height: "300px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalBodyItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  modalButton: {
    background: "#049c77",
    color: "white",
    width: "200px",
    height: "40px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  deleteJobIcon: {
    color: "red",
    cursor: "pointer",
  },
  feedbackModal: {
    background: "white",
    borderRadius: "5px",
    width: "600px",
    height: "400px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  feedbackModalMobile: {
    background: "white",
    borderRadius: "5px",
    width: "75%",
    height: "70%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  feedback: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderRadius: "10px",
    padding: "10px",
    background: "#eeffee",
    marginBottom: "2px",
    marginTop: "2px",
  },
  feedbackFooter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  popper: {
    background: "white",
    borderRadius: "5px",
    padding: "10px",
  },
  reportModalConfig: {
    background: "white",
    borderRadius: "5px",
    width: "500px",
    height: "300px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
  },
  reportModalConfigMobile: {
    background: "white",
    borderRadius: "5px",
    width: "90%",
    height: "200px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
  },
  reportModal: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: "2px solid #000",
    borderRadius: "5px",
    width: "60%" ,
    height: "90%",
    padding: "20px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // zIndex: '100',
    overflow: "auto",
    // display: 'none',
    opacity: 1,
  },
  reportModalMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: "2px solid #000",
    borderRadius: "5px",
    width: "90%",
    height: "80%",
    padding: "5px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // zIndex: '100',
    overflow: "auto",
    // display: 'none',
    opacity: 1,
  },
  reportTableHeaderItem: {
    textAlign: "center",
    verticalAlign: "middle",
    color: "#000",
  },
  reportTableBodyItem: {
    textAlign: "center",
    verticalAlign: "middle",
    maxHeight: "30px",
  },
  filterDate: {
    marginRight: "10px",
    marginLeft: "10px",
    border: "1px solid #000",
    borderRadius: "5px",
    padding: "5px",
  },

  // entries...
  entries: {
    display: "flex",
    flexDirection: "column",
    width: "95%",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 10px 0px 10px",
    // background: 'green',
  },
  entry: (status, findings) => ({
    minHeight: "100px",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    width: "100%",
    position: "relative",
    background:
      status === "Finished"
        ? findings === true
          ? "#ffcccb"
          : "#aaeecc"
        : "#E0E0E0",
    borderTop: "1px solid #888",
  }),
  entryopen: (status, findings) => ({
    minHeight: "100px",
    display: "flex",
    flexDirection: "column",
    padding: "10px 10px 20px 10px",
    width: "100%",
    position: "relative",
    background:
      status === "Finished"
        ? findings === true
          ? "#ffcccb"
          : "#aaeecc"
        : "#E0E0E0",
    borderTop: "1px solid #888",
  }),
  entryRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "5px",
  },
  entryRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "5px",
  },
  entryRowKey: {
    fontSize: "12pt",
    fontWeight: "700",
    color: "#000",
  },
  entryRowValue: {
    fontSize: "12pt",
    fontWeight: "400",
    color: "#000",
  },
  expandButtonWrapper: {
    position: "absolute",
    // left: "10px",
    alignSelf: "center",
    justifySelf: "center",
    bottom: "2px",
    padding: "10px",
    backgroundColor: "#077F8E",
    color: "white",
    fontSize: "12px",
    cursor: "pointer",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
  },
  dropdownContent: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    backgroundColor: "white",
    minWidth: "220px",
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
    zIndex: "1",
    borderRadius: "5px",
    border: "1px solid #077F8E",
    padding: "10px",
    // transform: 'translateX(-50%)',
    right: "5px",
    height: "fit-content",
  },

  dropdownContentItem: {
    padding: "5px",
    cursor: "pointer",
    color: "#000",
    "&:hover": {
      background: "#077F8E",
      color: "white",
    },
    display: "flex",
    alignItems: "center",
    margin: "5px",
    fontWeight: "100",
    fontSize: "1rem",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "#077F8E",
    color: "#fff",
    borderRadius: "50%",
    width: "16px",
    height: "16px",
    lineHeight: "16px",
    textAlign: "center",
    verticalAlign: "middle",
    fontSize: "9px",
    position: "relative",
    top: "-10px",
    left: "-2px",
  },
};

const Feedback = (props) => {
  return (
    <div style={styles.feedback}>
      <p style={{ fontSize: "12pt", fontWeight: "600" }}>
        {props.index}. {props.feedback}
      </p>
      <div style={styles.feedbackFooter}>
        <p style={{ fontSize: "10pt" }}>{props.feedbackBy}</p>
        <p style={{ fontSize: "10pt" }}>
          {new Date(props.feedbackDate).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            hour12: false,
          })}
        </p>
      </div>
    </div>
  );
};

const Status = (props) => {
  return (
    <div style={styles.statusWrapper}>
      <div style={props.statusObj(props.status)}></div>
      {props.status}
    </div>
  );
};

const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const Header = (props) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const centers = JSON.parse(localStorage.getItem("centers")) || ['aarthi'];

  const [searchText, setSearchText] = useState("");
  const displayedOptions = useMemo(
    () => centers.filter((option) => containsText(option, searchText)),
    [searchText]
  );
  const [LogoimgSrc, setLogoimgSrc] = useState("");
  const [notificationOpen, setnotificationOpen] = useState(false);
  function handleAddUser() {
    navigate("/admin/add-user");
  }

  function handleDropdown(dropdown) {
    setDropdownOpen(dropdown);
    if (dropdownOpen) {
      props.toggleDropdown();
    }
  }

  React.useEffect(() => {
    setDropdownOpen(props.dropdownOpen);
  }, [props.dropdownOpen]);

  React.useEffect(() => {
    let srcX = createImageFromInitials(500, props.user, getRandomColor());
    setLogoimgSrc(srcX);
  }, []);

  return (
    <div style={styles.header}>
      <div style={styles.dashboardWrapper}>
        <div
          style={styles.menuButtonWrapper}
          className="menuButtonWrapper"
          onClick={props.toggleDrawer}
        >
          {props.admin ? (
            <MenuIcon
              style={styles.menuButton}
              onClick={(e) => {
                e.stopPropagation();
                // open drawer
                props.toggleDrawer();
              }}
            />
          ) : null}
        </div>
        {eval(props.admin) ? (
          <Select
            style={styles.dashboardSelect}
            value={props.center}
            onChange={(e) => props.handleCenterChange(e.target.value)}
            onClose={() => setSearchText("")}
            MenuProps={{
              sx: {
                "&& .Mui-selected": {
                  backgroundColor: "#049c77",
                  color: "#fff",
                },
                "& .MuiMenuItem-root:hover": {
                  backgroundColor: "pink",
                },
              },
              autoFocus: false,
            }}
            renderValue={() => props.center.toUpperCase()}
          >
            <ListSubheader>
              <TextField
                size="small"
                // Autofocus on textfield
                autoFocus
                placeholder="Type to search..."
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            {displayedOptions.map((center, i) => (
              <MenuItem
                value={center}
                key={i}
                // onClick={() => props.handleCenterChange(center)}
                // style={{ background: props.center === center ? '#049c77' : '#fff', color: props.center === center ? '#fff' : '#000' }}
              >
                {center.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <p style={styles.dashboardHeaderText}>{props.center.toUpperCase()}</p>
        )}
      </div>
      <div
        style={styles.logoutWrapper}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/*
        <div>
          <div
            style={{
              width: "30px",
              height: "30px",
            }}
          >
            <Badge
              badgeContent={props.notifications.length}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "red",
                },
              }}
            >
              <CircleNotificationsRoundedIcon
                color="white"
                style={{
                  fill: "#fff",
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setnotificationOpen(!notificationOpen);
                  // props.setProfile(false);
                }}
              />
            </Badge>
          </div>
          <div
            className={notificationOpen ? "mounted" : "unmounted"}
            style={styles.dropdownContent}
          >
            {props.notifications.map((notification, index) => (
              <p
                style={{ color: "black" }}
                key={index}
                onClick={() => console.log("clieck")}
              >
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      Job ID
                    </Typography>
                    <Typography variant="h5" component="div">
                      {notification["job_id"]}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                      {notification["center"]}
                    </Typography>
                    <Typography variant="body2">
                      status :
                      <br />
                      {notification["status"]}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      variant="contained"
                      color="success"
                      onClick={() => {
                        props.handleCenterChange(
                          notification["center"].match(/.{1,4}/g).join("_")
                        );
                        props.setFilterText(notification["job_id"]);
                      }}
                    >
                      navigate to case
                    </Button>
                  </CardActions>
                </Card>
              </p>
            ))}
          </div>
        </div> 
            */}
        

        <div style={styles.dropdown}>
          <div
            style={{
              width: "30px",
              height: "30px",
            }}
          >
            <ProfileIcon
              onClick={() => {
                props.toggleDropdown();
              }}
              style={{
                fill: "#fff",
                width: "30px",
                height: "30px",
                cursor: "pointer",
              }}
            />
          </div>
          <div
            className={dropdownOpen ? "mounted" : "unmounted"}
            style={styles.dropdownContent}
          >
            <p
              style={{
                ...styles.dropdownContentItem,
                cursor: "default",
                borderBlockEnd: "2px solid #0087ca",
                fontWeight: "500",
              }}
            >
              <img
                id="preview"
                className="userLogo"
                src={LogoimgSrc}
                alt="profile-pic"
              />
              {props.user}
            </p>
            <p
              className="dropActionlnk"
              style={styles.dropdownContentItem}
              onClick={props.logout}
            >
              <span className="userLogo">
                <PowerSettingsNewIcon />
              </span>
              Logout
            </p>
            {props.admin && (
              <p
                className="dropActionlnk"
                style={styles.dropdownContentItem}
                onClick={handleAddUser}
              >
                <span className="userLogo">
                  <PersonAddIcon />
                </span>
                Add User
              </p>
            )}
            <p
              className="dropActionlnk"
              style={styles.dropdownContentItem}
              onClick={props.resetPassword}
            >
              <span className="userLogo">
                <LockResetIcon />
              </span>
              Reset Password
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Report = (props) => {
  if (props.admin) {
    return (
      <td style={props.mobile ? styles.tableBodyItemMobile : styles.tableBodyItem}>
        <SummarizeIcon
          style={{
            fill: "#077F8E",
            cursor: "pointer",
          }}
          onClick={props.onSummarizeClick}
        />
      </td>
    );
  } else {
      return (
        <td style={styles.tableBodyItem}>
          {(props.job.reportStatus !== "Processing" && props.job.reportStatus !== "processing" && props.job.reportStatus !== false) ? (
            <div>
              <Tooltip title={`CAC Score: ${props.job.approvedCacScore}`} >
                <SaveIcon
                  style={{
                    fill: "#077F8E",
                    cursor: "pointer",
                    // opacity: props.job.reportStatus !== "completed" ? 0.5 : 1,
                  }}
                  // onClick={props.onSaveClick}
                  onClick={() => {
                    if (props.job.reportStatus === "Processing" || props.job.reportStatus === "processing" || props.job.reportStatus === false) {
                      return;
                    }
                    props.setOpenJobID(props.job.jobId);
                    if(props.job.reportStatus === "completed") props.setReportModalOpen(true);
                    else props.setReportModalOpen2(true);
                  }}
                />
              </Tooltip>

              {/* <Link to={`/report/${props.job.jobId}`}>
                <EditIcon
                  style={{
                    fill: "#077F8E",
                    cursor: "pointer",
                    opacity: props.job.reportStatus !== "completed" ? 0.5 : 1,
                  }}
                />
              </Link> */}

            </div>
          ) : null}
        </td>
      );
    }
};

const Entry = (props) => {
  // const [expanded, setExpanded] = React.useState(false);
  const admin=props.isAdmin;
  const baseURLAPI=props.baseURLAPI;
  const baseURL= props.baseURL;
  const center=props.center;
  const navigate = useNavigate();

  // React.useEffect(() => {
  //   setExpanded(props.expanded);
  // }, [props.expanded]);
  // console.log("entry: ", props.job);
  if (props.expanded) {
    console.log("expanded: ", props.job);
    return (
      <div 
        style={styles.entryopen(props.job.status, props.job.findings, props.job.approvedCacScore)}
        onClick={() => props.setExpanded(false)}
      >
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Job ID</div>
          <div style={styles.entryRowValue} onClick={() => {}}>
            {props.job.jobId.substring(0, 8)}
          </div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Patient Name</div>
          <div style={styles.entryRowValue}>
            {props.job.patientName.substring(0, 20)}
          </div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Patient ID</div>
          <div style={styles.entryRowValue}>{props.job.patientId}</div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>From</div>
          <div style={styles.entryRowValue}>{props.job.dataFrom}</div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Status</div>
          <div style={styles.entryRowValue}>
          {admin ? (
              <Status
                status={props.job.status}
                statusObj={styles.statusObjAdmin}
              />
            ) : (
              <Status
                status={
                  props.job.reportStatus ||
                  (props.job.status.toLowerCase() === "queued" &&
                  props.job.status) ||
                  (props.job.status.toLowerCase() === "failed" &&
                  props.job.status) ||
                  "Processing"
                }
                statusObj={styles.statusObj}
              />
            )}
          </div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Received At</div>
          <div style={styles.entryRowValue}>
            {new Date(props.job.receivedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              hour12: false,
            })}
          </div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Completed At</div>
          <div style={styles.entryRowValue}>
            {props.job.completedAt
              ? new Date(props.job.completedAt).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                  hour12: false,
                })
              : ""}
          </div>
        </div>

        <div style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: admin ? "space-between" : "center",
          alignItems: "center",
          width: "100%",
          marginTop: "20px",
        }}>
          
          {/* Sequences */}
          {admin ?  
            <Tooltip title="Sequence" >
              <div style={styles.entryRowValue}>
                <VisibilityIcon
                  style={{
                    fill: "#1b4b84",
                    height:"18.4px",
                    cursor: props.job.status === "Failed" ? "not-allowed" : "pointer",
                    opacity: props.job.status === "Failed" ? 0.5 : 1,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.job.status === "Failed") {
                      return;
                    }
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");
                    axios
                      .get(
                        `${baseURLAPI}/admin/job_sequences/${props.job.jobId}`,
                        {
                          headers: {
                            Authorization: "Bearer " + token,
                          },
                        }
                      )
                      .then((res) => {
                        const response = res.data;
                        console.log("response", response);
                        props.setMetadata(response.metadata);
                        props.setSequence(response.selected_sequence);
                        props.setSelectedSequence(
                          response.selected_sequence
                        );
                        props.setJobId(props.job.jobId);
                        props.refreshImage(
                          props.job.jobId,
                          response.selected_sequence
                        );
                      })
                      .catch((err) => {
                        console.log(err);
                      });

                    props.setSequencesModalOpen(true);
                  }}
                />
              </div>
            </Tooltip>  
            : null
          }

          {/* Annotate */}
          {admin ? 
            <Tooltip title="Annotate" >
              <div style={styles.entryRowValue}>
                <OpenInNewIcon
                  style={{
                    fill: "#1b4b84",
                    height:"18.4px",
                    cursor: props.job.status === "Failed" ? "not-allowed" : "pointer",
                    opacity: props.job.status === "Failed" ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (props.job.status === "Failed") {
                    return;
                  }
                    navigate(`/view/${props.job.jobId}`);
                  }}
                />
              </div>
            </Tooltip>  
          : null}

          {/* Report */}
          {(admin || props.job.reportStatus) &&
            <Tooltip title="Report" >
              <div style={styles.entryRowValue}>
                {/* {!admin && <span>Download Report</span>} */}
                <Report
                  mobile={props.mobile}
                  job={props.job}
                  admin={admin}
                  center={props.center}
                  onSummarizeClick={(e) => {
                    e.stopPropagation();
                    if (props.job.status === "Failed") {
                    return;
                  }
                    props.setJobId(props.job.jobId);
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");
                    props.getConfigs(props.job.jobId);
                  }}
                  onSaveClick={(e) => {
                    e.stopPropagation();
                    if (!admin && props.job.reportStatus !== "completed") return; 
                    if (props.job.status === "Failed") {
                      return;
                    }
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");

                    axios({
                      method: "GET",
                      url: `${baseURL}/report/${props.job.jobId}`,
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                      responseType: "arraybuffer",
                    })
                      .then((res) => {
                        // download file
                        console.log("res", res);
                        let blob = new Blob([res.data], {
                          type: "application/pdf",
                        });
                        let url = window.URL.createObjectURL(blob);
                        let link = document.createElement("a");
                        link.href = url;
                        link.download = `${props.job.patientName}.pdf`;
                        link.click();
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                />
              </div>
            </Tooltip>  
          }

          {/* Feedback */}
          {admin && 
            <Tooltip title="Feedback" >
              <div style={styles.entryRowValue}>
                <Button
                  style={{
                      fill: "#1b4b84",
                      height:"18.4px", 
                      padding: "0",
                      minWidth:"0",
                      cursor: props.job.status === "Failed" ? "not-allowed" : "pointer",
                      opacity: props.job.status === "Failed" ? 0.5 : 1,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (props.job.status === "Failed") {
                        return;
                      }
                      const token = admin
                        ? localStorage.getItem(`token-${center}`)
                        : localStorage.getItem("token");
                      axios
                        .get(
                          `${baseURLAPI}/feedback?job_id=${props.job.jobId}`,
                          {
                            headers: {
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        )
                        .then((res) => {
                          console.log("feedbacks", res);
                          props.setFeedbacks(res.data.feedback);
                          props.setFeedbackModalOpen(true);
                          props.setJobId(props.job.jobId);
                        })
                        .catch((err) => {
                          console.log("err", err);
                        });
                    }}
                >
                  <CommentIcon
                      style={{
                      fill: "#1b4b84",
                      height:"18.4px", 
                      width:"20px",
                      padding: "0",
                      minWidth:"0"
                    }}
                  />
                </Button>
              </div>
            </Tooltip>  
          }

          {/* Warnings */}
          <Tooltip title="Warnings" >
            <div style={styles.entryRowValue}>
            {admin ? (
                <div
                  style={ {
                    textAlign: "center",
                    verticalAlign: "middle",
                    height: "18.4px",
                    // width:"0px",
                  }}
                  onMouseOver={(e) => {
                    console.log("job status", props.job.status);
                    if (props.job.status !== "Failed") {
                      if (
                        Object.values(props.job.warnings || {}).reduce(
                          (a, b) => a + b.length,
                          0
                        ) > 0
                      ) {
                        props.setJobId(props.job.jobId);
                        props.setToastMessage(props.job.warnings);
                        props.setWarningsOpen(true);
                        props.setToastAnchorEl(e.currentTarget);
                        setTimeout(() => {
                          props.setWarningsOpen(false);
                          props.setToastMessage("");
                        }, 2000);
                      }
                      console.log("no warnings");
                    } else {
                      // set cursor to pointer
                      e.currentTarget.style.cursor = "pointer";
                      console.log("getting errors");
                      const target = e.currentTarget;
                      // get errors from server
                      const token = admin
                        ? localStorage.getItem(`token-${center}`)
                        : localStorage.getItem("token");
                      axios
                        .get(
                          `${baseURLAPI}/errors?job_id=${props.job.jobId}`,
                          {
                            headers: {
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        )
                        .then((res) => {
                          console.log(res.data.errors, "errors");
                          props.setJobId(props.job.jobId);
                          props.setErrorsOpen(true);
                          props.setToastMessage(res.data.errors);
                          console.log(
                            e.currentTarget,
                            "current target"
                          );
                          props.setToastAnchorEl(target);
                          setTimeout(() => {
                            props.setErrorsOpen(false);
                            props.setToastMessage("");
                          }, 8000);
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.job.status === "Failed") {
                      // download log file
                      const token = admin
                        ? localStorage.getItem(`token-${center}`)
                        : localStorage.getItem("token");
                      axios({
                        method: "GET",
                        url: `${baseURLAPI}/log?job_id=${props.job.jobId}`,
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                        // responseType: "arraybuffer",
                      })
                        .then((res) => {
                          // download file
                          console.log("res", res);

                          let blob = new Blob([res.data], {
                            type: "text/plain",
                          });
                          let url = window.URL.createObjectURL(blob);
                          let link = document.createElement("a");

                          link.href = url;
                          link.download = `${props.job.jobId}.log`;
                          link.click();
                        })
                        .catch((err) => {
                          console.log("err", err);
                        });
                    }
                  }}
                >
                  {props.job.status === "Finished"
                    ? Object.values(props.job.warnings || {}).reduce(
                        (a, b) => a + b.length,
                        0
                      )
                    : null}
                  {props.job.status === "Failed" ? (
                    <ErrorIcon style={{ 
                      fill: "#1b4b84",
                      cursor: "pointer",
                      height:"18.4px", }} />
                  ) : null}
                </div>
              ) : null}
            </div>
          </Tooltip>  

          {/* Actions */}
          {admin ? 
            <Tooltip title="Edit" >
            <div style={styles.entryRowValue}>
              <EditIcon
                style={{ color: "green", cursor: "pointer", height: "18.4px", }}
                onClick={(e) => {
                  e.stopPropagation();
                  console.log("edit job", props.job);
                  props.setUpdatedJob(props.job);
                  props.setEditModalOpen(true);
                }}
              />
            </div>
            </Tooltip>  
          : null}

          {admin ? 
            <Tooltip title="Delete" >
              <div style={styles.entryRowValue}>
                <DeleteForever
                  style={{ color: "red", cursor: "pointer", height: "18.4px", }}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setDeleteJob(props.job);
                    props.setDeleteModalOpen(true);
                  }}
                />
              </div>
            </Tooltip>
          : null}

          {admin ? (props.job.status != "finished" && (
            <Tooltip title="Stop" >
              <div style={styles.entryRowValue}>
                <StopCircleIcon
                  style={{ color: "red", cursor: "pointer", height: "18.4px", }}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setStopJob(props.job);
                    props.setStopModalOpen(true);
                  }}
                />
              </div>
            </Tooltip>  
          )) : null }

        </div>
      </div>
    );
  } else {
    return (
      <div 
        style={styles.entry(props.job.status, props.job.findings, props.job.approvedCacScore)}
        onClick={() => props.setExpanded(true)}
      >
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Job ID</div>
          <div style={styles.entryRowValue}>
            {props.job.jobId.substring(0, 8)}
          </div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Patient Name</div>
          <div style={styles.entryRowValue}>
            {props.job.patientName}
          </div>
        </div>
        <div style={styles.entryRow}>
          <div style={styles.entryRowKey}>Patient ID</div>
          <div style={styles.entryRowValue}>{props.job.patientId}</div>
        </div>
        {/* <div
          style={styles.expandButtonWrapper}
          onClick={() => setExpanded(true)}
        >
          <ExpandMoreIcon
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div> */}
      </div>
    );
  }
};

const Entries = (props) => {
  // console.log('entries', props);
  // 10 false
  const [expanded, setExpanded] = React.useState(Array(10).fill(false));
  console.log("jobs", props.jobs);
  return (
    <div style={styles.entries}>
      {props.jobs.map((job, index) => (
        <Entry
          key={index}
          job={job}
          center={props.center}
          statusObj={props.statusObj}
          isAdmin={props.isAdmin}
          baseURLAPI={props.baseURLAPI}
          imgSrc={props.imgSrc}
          refreshImage={props.refreshImage}
          baseURL={props.baseURL}
          setToastMessage={props.setToastMessage}
          setToastOpen={props.setToastOpen}
          setToastAnchorEl={props.setToastAnchorEl}
          getConfigs={props.getConfigs}
          setJobId={props.setJobId}
          setFeedbackModalOpen={props.setFeedbackModalOpen}
          setFeedbacks={props.setFeedbacks}
          setWarningsOpen={props.setWarningsOpen}
          setErrorsOpen={props.setErrorsOpen}
          setUpdatedJob={props.setUpdatedJob}
          setEditModalOpen={props.setEditModalOpen}
          setDeleteJob={props.setDeleteJob}
          setDeleteModalOpen={props.setDeleteModalOpen}
          setStopJob={props.setStopJob}
          setStopModalOpen={props.setStopModalOpen}
          mobile={props.mobile}
          setMetadata={props.setMetadata}
          sequence={props.sequence}
          setSequence={props.setSequence}
          setSelectedSequence={props.setSelectedSequence}
          sequencesModalOpen={props.sequencesModalOpen}
          setSequencesModalOpen={props.setSequencesModalOpen}
          setExpanded={(value) => {
            let temp = [...expanded];
            temp[index] = value;
            setExpanded(temp);
          }
          }
          expanded={expanded[index]}
        />
      ))}
    </div>

    // <Table id="jobsTable" style={styles.table(window.innerHeight)}>
    //   <TableHead>
    //     <TableRow style={{ background: "#077F8E" }}>
    //       <th style={styles.tableHeaderItem}>Job ID</th>
    //       <th style={styles.tableHeaderItem}>From</th>
    //       <th style={styles.tableHeaderItem}>Patient ID</th>
    //     </TableRow>
    //   </TableHead>
    //   <TableBody>
    //     {props.jobs.map((job) => (
    //       <tr
    //         key={job.jobId}
    //         style={styles.tableRow(job.status, job.findings, job.approvedCacScore)}
    //         className="tableRow-3d"
    //       >
    //         <td style={styles.tableBodyItem}>{job.patientId}</td>
    //         <td style={styles.tableBodyItem}>{job.patientName}</td>
    //         <td style={styles.tableBodyItem}>{job.age}</td>
    //       </tr>
    //     ))}
    //   </TableBody>
    // </Table>
  );
};

export default function Jobs(props) {
  // get navigate state

  const location = useLocation();
  // console.log("location", location);
  const locationQuery = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const [jobs, setJobs] = useState([]);
  const [showAll, setShowAll] = useState(
    (locationQuery.get("showAll") && locationQuery.get("showAll") === "true") ||
      true
  );
  const [jobUpdated, setJobUpdated] = useState(0);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [jobId, setJobId] = useState("");
  const [newFeedback, setNewFeedback] = useState("");
  const feedbackValues = [
    "Stent",
    "Normal",
    "Abnormal",
    "Aortic Calcifications",
    "Artifacts",
    "Valve Calcifications",
    "FP"
  ];
  const [feedbackSelected, setfeedbackSelected] = useState([]);

  const [Filter, setFilter] = useState("Filter by text");
  const [feedbacks, setFeedbacks] = useState([]);
  const [page, setPage] = useState(
    (locationQuery.get("page") && parseInt(locationQuery.get("page"))) || 0
  );
  const [filterText, setFilterText] = useState(
    locationQuery.get("filterText") || ""
  );
  const [filterFeedbackText, setFilterFeedbackText] = useState(
    locationQuery.get("filterFeedbackText") || ""
  );
  const [filterRiskText, setFilterRiskText] = useState(
    locationQuery.get("filterRiskText") || ""
  );
  const [startDate, setStartDate] = useState(
    locationQuery.get("startDate") || "1970-01-01"
  );
  const [endDate, setEndDate] = useState(
    locationQuery.get("endDate") || "2100-01-01"
  );
  const [updatedJob, setUpdatedJob] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteJob, setDeleteJob] = useState({});
  const [stopJob, setStopJob] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [stopModalOpen, setStopModalOpen] = useState(false);

  const [reportModalConfigOpen, setReportModalConfigOpen] = useState(false);
  const [reportConfigs, setReportConfigs] = useState([]);

  const [loading, setLoading] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [toastAnchorEl, setToastAnchorEl] = useState(null);
  const [toastPlacement, setToastPlacement] = useState("");

  const [warningsOpen, setWarningsOpen] = useState(false);
  const [errorsOpen, setErrorsOpen] = useState(false);

  const [sequencesModalOpen, setSequencesModalOpen] = useState(false);

  const [metadata, setMetadata] = React.useState({});
  const [sequence, setSequence] = React.useState("");
  const [selectedSequence, setSelectedSequence] = React.useState("");
  const [imgSrc, setImgSrc] = React.useState("");

  const [baseURL, setBaseURL] = useState("");
  const [baseURLAPI, setBaseURLAPI] = useState("");
  const [ohifURL, setOhifURL] = useState("");
  const [center, setCenter] = useState("");
  const [admin, setAdmin] = useState(false);

  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);


  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const [mobile, setMobile] = useState(false);

  const [loggedIn, setLoggedIn] = useState(true);

  const [notifications, setNotifications] = useState([]);

  const [socket, setSocket] = useState(null);

  const [mergeModal, setMergeModal] = useState(false);

  const [fileObjects, setFileObjects] = useState([]);

  const [pdfFile, setPdfFile] = React.useState(null);
  const [pdfData, setPdfData] = React.useState(null);
  const [pdfNumPages, setPdfNumPages] = React.useState(1);
  const [pdfIndex, setPdfIndex] = React.useState(0);
  const [reportLoading, setReportLoading] = React.useState(false);
  const [reportModalOpen, setReportModalOpen] = React.useState(false);
  const [reportModalOpen2, setReportModalOpen2] = React.useState(false);
  const [openJobID, setOpenJobID] = React.useState("");
  let pdfRef = React.useRef(null);

  window.addEventListener('keyup', (e) => {
    if (reportModalOpen2) {
      if (e.key === 'PrintScreen') {
        e.preventDefault();
        setReportModalOpen2(false)
      }
      if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey || e.key === 'F12' || e.key === 'F11' || e.key === 'F10' || e.key === 'F9' || e.key === 'F8' || e.key === 'F7' || e.key === 'F6' || e.key === 'F5' || e.key === 'F4' || e.key === 'F3' || e.key === 'F2' || e.key === 'F1') {
        e.preventDefault();
        setReportModalOpen2(false)
      }
    }
  });

useEffect(() => {
  const handleKeyDown = (e) => {
    if (reportModalOpen2) {
      const allowedKeys = [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
      ];
      if (!allowedKeys.includes(e.key)) {
        setReportModalOpen2(false);
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
  };

  window.addEventListener("keydown", handleKeyDown, true);

  return () => {
    window.removeEventListener("keydown", handleKeyDown, true);
  };
}, [reportModalOpen2]);


  
  const [images, setImages] = useState([]);
  useEffect(() => {
    if (reportModalOpen2) {
      setReportLoading(true);
      const token = admin
        ? localStorage.getItem(`token-${center}`)
        : localStorage.getItem("token");
      axios.get(`${baseURL}/report/${openJobID}/show_pdf_images`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(res => {
          setImages(res.data);
          setReportLoading(false);
        })
        .catch(err => {
          console.error("Error fetching PDF images:", err);
          setReportLoading(false);
        });
    }
  }, [reportModalOpen2, openJobID]);

  const getPdfData = async () => {
    const token = admin
    ? localStorage.getItem(`token-${center}`)
    : localStorage.getItem("token");
    const res = await fetch(`${baseURL}/report/${openJobID}/show_pdf`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setPdfData(res.data);

    let blob = await res.blob();

    const f = new File([blob], "report.pdf", { type: "application/pdf" });
    setPdfFile(f);
    // setPdfFile(new File([blob], 'report.pdf', { type: 'application/pdf' }));
    let url = window.URL.createObjectURL(blob);
    setReportLoading(false);
    if (pdfRef.current === null) return;
    pdfRef.current.src = url;
    // pdfRef.current.src = `${url}#toolbar=0&navpanes=0&scrollbar=0`;

  };

  React.useEffect(() => {
      if (reportModalOpen && pdfRef !== null) {
        const token = admin
          ? localStorage.getItem(`token-${center}`)
          : localStorage.getItem("token");
        setReportLoading(true);
        if (
          typeof window !== "undefined" &&
          window.navigator &&
          window.navigator.mimeTypes &&
          window.navigator.mimeTypes["application/pdf"]
        ) {
          getPdfData();
        } else {
          getPdfData();
          axios({
            method: "GET",
            url: `${baseURL}/report/${openJobID}/show_pdf`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
            // responseType: 'arraybuffer'
          })
            .then((res) => {
              // download file
  
              // let blob = new Blob([res.data], { type: 'application/pdf' });
              // let url = window.URL.createObjectURL(blob);
              // console.log('pdfRef', pdfRef);
              // pdfRef.current.src = url;
  
              setPdfData(res.data);
  
              let blob = new Blob([res.data], { type: "application/pdf" });
              setPdfFile(
                new File([blob], "report.pdf", { type: "application/pdf" })
              );
              let url = window.URL.createObjectURL(blob);
              if (pdfRef.current === null) return;
              pdfRef.current.src = url;
            })
            .catch((err) => {
              console.log("error in fetching report", err);
            })
            .finally(() => {
              setReportLoading(false);
            });
        }
      }
    }, [reportModalOpen, pdfRef]);

  const [play] = useSound(boopSfx);

  // console.log(
  //   location,
  //   locationQuery.get("page"),
  //   locationQuery.get("page") || 1,
  //   page,
  //   "location"
  // );
  const DialogTitleMerge = () => (
    <>
      <span>Merge PDF report file</span>
      <IconButton
        style={{ right: "12px", top: "8px", position: "absolute" }}
        onClick={() => setMergeModal(false)}
      >
        <Close />
      </IconButton>
    </>
  );

  React.useEffect(() => {
    console.log("getting center and admin");
    // get center from local storage
    const center = localStorage.getItem("center");
    const admin = localStorage.getItem("admin");

    setCenter(center);
    setAdmin(admin === "true");

    if (!center || !admin) {
      setLoggedIn(false);
    }

    console.log(center, admin, "center and admin");

    setBaseURL(inferURLs[center]);
    setBaseURLAPI(apiURLs[center]);
    setOhifURL(ohifURLs[center]);

    window.addEventListener("resize", () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    });

    // close dropdown on click outside
    document.body.addEventListener("click", (e) => {
      // console.log(e.target, !e.target.id, "e.target.id", "click");
      if (!e.target.id || e.target.id !== "profileDropdown") {
        console.log("setting profile dropdown to false");
        setProfileDropdownOpen(false);
      }
    });
  }, []);

  React.useEffect(() => {
    // on change dimensions, check if width is less than 600px
    if (dimensions.width < 600) {
      // if yes remove table columns and allow them to be expanded
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, [dimensions]);

  useEffect(() => {
    let socket = io("https://inference1.urologiq.ai", {
      path: "/notifications/socket.io",
      // transports: ['websocket'],
    });
    console.log(socket, "socket");
    setSocket(socket);

    return () => {
      console.log("disconnecting socket");
      socket.disconnect();
    };
  }, []);

  // React.useEffect(() => {
  //   if (!socket) return;
  //   // function playSound(url) {
  //   //   const audio = new Audio(url);
  //   //   audio.play();
  //   // }
  //   socket.on("case_notification", (data) => {
  //     console.log(data, "data");
  //     setNotifications((notifications) => [
  //       ...notifications,
  //       JSON.parse(data.notification),
  //     ]);
  //     // navigator.mediadevices.getusermedia({ audio: true });
  //     play();
  //   });
  // }, [socket]);

  // console.log(notifications, "notifications");

  const onGetJobsError = (err) => {
    if (admin) {
      // just display the error message and ask to login again
      console.log(err, "err");
      setToastMessage(err.message + ". Please login again.");
      setToastOpen(true);
      setToastAnchorEl(document.getElementById("jobsTable"));
      setToastPlacement("bottom");
      setTimeout(() => {
        setToastOpen(false);
        setToastPlacement("");
      }, 3000);
    } else {
      // if not admin, then the token has expired
      // redirect to login page
      setLoggedIn(false);
    }
  };

  React.useEffect(() => {
    console.log(baseURL);
    if (baseURL !== "") {
      console.log("getting jobs");
      setLoading(true);
      setJobs([]);
      const token = admin
        ? localStorage.getItem(`token-${center}`)
        : localStorage.getItem("token");
      axios
        .get(
          `${baseURL}/jobs?show_all=${showAll}&page=${page}&text_filter=${filterText}&feedback=${filterFeedbackText}&risk=${filterRiskText}&start_date=${startDate}&end_date=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setJobs(res.data.jobs);
        })
        .catch((err) => {
          onGetJobsError(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    showAll,
    jobUpdated,
    page,
    filterText,
    filterFeedbackText,
    filterRiskText,
    baseURL,
    startDate,
    endDate,
    center
  ]);

  const handleCenterChange = (center) => {
    console.log(center, "center", inferURLs[center], apiURLs[center]);
    setCenter(center);
    setBaseURL(inferURLs[center]);
    setBaseURLAPI(apiURLs[center]);
    setOhifURL(ohifURLs[center]);
    localStorage.setItem("center", center);
  };

  const refreshImage = (jobId, sequence) => {
    // set loading image source
    setImgSrc("https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif");
    const token = admin
      ? localStorage.getItem(`token-${center}`)
      : localStorage.getItem("token");
    axios
      .get(`${baseURL}/sample_sequence_images/${jobId}/${sequence}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        // base64
        setImgSrc("data:image/png;base64," + res.data.image);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getConfigs = (jobId) => {
    const token = admin
      ? localStorage.getItem(`token-${center}`)
      : localStorage.getItem("token");
    axios
      .get(`${baseURLAPI}/configs_sent?job_id=${jobId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("configs", res.data);
        let configs_sent = res.data.configs;
        for (let i in configs_sent) {
          let gmtDate = new Date(configs_sent[i].config_time);
          let istDate = gmtDate.toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });
          configs_sent[i].config_time = istDate;
        }
        console.log("IST time configs", configs_sent);
        setReportConfigs(configs_sent);
        setReportModalConfigOpen(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let inputRef = null;

  function searchquery(value) {
    if (Filter == "Filter by text") {
      setFilterText(value);
      setFilterFeedbackText("");
      setFilterRiskText("");
      navigate(
        `/jobs?showAll=${showAll}&page=${page}&filterText=${value}&startDate=${startDate}&endDate=${endDate}`
      );
    } else if (Filter == "Filter by feedback") {
      setFilterFeedbackText(value);
      setFilterText("");
      setFilterRiskText("");
      navigate(
        `/jobs?showAll=${showAll}&page=${page}&filterFeedbackText=${value}&startDate=${startDate}&endDate=${endDate}`
      );
    }
    else if (Filter == "Filter by risk") {
      setFilterText("");
      setFilterFeedbackText("");
      setFilterRiskText(value);
      navigate(
        `/jobs?showAll=${showAll}&page=${page}&filterRiskText=${value}&startDate=${startDate}&endDate=${endDate}`
      );
    }
  }

  if (baseURL === "") {
    return (
      // show loading
      <div style={styles.wrapper}>
        <Header
          user={localStorage.getItem("username")}
          admin={admin}
          handleCenterChange={handleCenterChange}
          logout={() => onLogout({ admin: admin, center: center })}
          center={center}
          dropdownOpen={profileDropdownOpen}
          notifications={notifications}
          toggleDropdown={() => setProfileDropdownOpen(!profileDropdownOpen)}
          resetPassword={() => navigate("/password_reset")}
          toggleDrawer={() => {
            console.log("toggle drawer", drawerOpen);
            setDrawerOpen(!drawerOpen);
          }}
        />
        <CircularProgress
          style={{ color: "#077F8E", margin: "auto", marginTop: "100px" }}
        />
      </div>
    );
  }

  if (!loggedIn) {
    return <Navigate to="/login" />;
  }

  let uploadCenters = [
    "aarthi",
    "gic_cropped",
    "nirman",
    "medimax",
    "deeptek",
    "ayucare",
    "nanavati",
    "trial",
    "gic",
    "sardarpatel",
    "bibharuch",
    "bivadodara",
    "genx",
    "ishan",
    "aster",
    "cect",
  ];

  console.log("jobs", jobs);

  return (
    <div style={styles.wrapper}>
      
      <Header
        user={localStorage.getItem("username")}
        admin={admin}
        handleCenterChange={handleCenterChange}
        logout={() => onLogout({ admin: admin, center: center })}
        center={center}
        dropdownOpen={profileDropdownOpen}
        setFilterText={searchquery}
        notifications={notifications}
        toggleDropdown={() => setProfileDropdownOpen(!profileDropdownOpen)}
        resetPassword={() => navigate("/password_reset")}
        toggleDrawer={() => {
          console.log("toggle drawer", drawerOpen);
          setDrawerOpen(!drawerOpen);
        }}
      />

      <div style={styles.container}>
        {admin ? (
          <div style={drawerOpen ? styles.drawer : styles.closedDrawer}>
            <img
              src={logo}
              style={{ width: "100%", height: "auto", marginBottom: "20px", marginTop: "20px" }}
            />
            <div style={styles.drawerContent}>
              <div
                className={
                  location.pathname === "/jobs"
                    ? "drawerItem Active"
                    : "drawerItem Inactive"
                }
                onClick={() => navigate("/jobs")}
              >
                <ListIcon style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Jobs
                </p>
              </div>
              <div
                className={
                  location.pathname === "/jobsall"
                    ? "drawerItem Active"
                    : "drawerItem Inactive"
                }
                onClick={() => navigate("/admin/jobsall")}
              >
                <ListIcon style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  All Centers Jobs
                </p>
              </div>
              <div
                className={
                  location.pathname === "/tasks"
                    ? "drawerItem Active"
                    : "drawerItem Inactive"
                }
                onClick={() => navigate("/admin/tasks")}
              >
                <ListIcon style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Tasks List
                </p>
              </div>
              <div
                className={
                  location.pathname === "/analytics"
                    ? "drawerItem Active"
                    : "drawerItem Inactive"
                }
                onClick={() => navigate("/analytics")}
              >
                <BarChartIcon style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Analytics
                </p>
              </div>
              <div
                className={
                  location.pathname === "/user-management"
                    ? "drawerItem Active"
                    : "drawerItem Inactive"
                }
                onClick={() => navigate("/admin/user-management")}
              >
                <PersonAddIcon style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  User Management
                </p>
              </div>
              <div
                className={
                  location.pathname === "/gatewaystatus"
                    ? "drawerItem Active"
                    : "drawerItem Inactive"
                }
                onClick={() => navigate("/admin/gatewaystatus")}
              >
                <BarChartIcon style={{ marginRight: "10px" }} />
                <p
                  style={{
                    margin: "0px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Gateway Status
                </p>
              </div>
            </div>
          </div>
        ) : null}
        <div style={styles.content}>
          {!mobile &&
            <Button
              className={mobile ? filterDrawerOpen ? "mounted" : "unmounted" : undefined}
              variant="contained"
              style={{
                backgroundColor: "#077F8E",
                color: "#fff",
                marginBlock: "10px",
              }}
              onClick={() => {
                navigate("/admin/upload");
              }}
            >
              Upload New Job
            </Button>
          }
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent:"space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <div>
              <Switch
                checked={showAll}
                style={{
                  alignItems: "left",
                  fill: "#077F8E",
                }}
                onChange={(e) => {
                  // console.log(val);
                  setShowAll(e.target.checked);
                  navigate(
                    `/jobs?showAll=${e.target.checked}&page=${page}&textFilter=${filterText}`
                  );
                  // getData();
                }}
              />{" "}
              Show All
            </div>
            {mobile ? 
              <Button
                style={{color:"black"}}
                onClick={() => setFilterDrawerOpen(!filterDrawerOpen)}
              > <FilterListIcon /> Filter 
              </Button> 
            : 
              <div>
                <Button
                  variant="text"
                  disabled={page <= 0}
                  style={{
                    color: page <= 0 ? "#888" : "#077F8E",
                  }}
                  onClick={() => {
                    console.log("previous page");
                    if (page > 0) {
                      setPage(page - 1);
                      navigate(
                        `/jobs?showAll=${showAll}&page=${
                          page - 1
                        }&filterText=${filterText}`
                      );
                    }
                  }}
                >
                  <ArrowBackIcon />
                </Button>
                <span style={{ color: "black" }}>{parseInt(page) + 1}</span>
                <Button
                  variant="text"
                  disabled={jobs.length < 10}
                  style={{
                    color: jobs.length < 10 ? "#888" : "#077F8E",
                  }}
                  onClick={() => {
                    console.log("next page");
                    setPage(page + 1);
                    navigate(
                      `/jobs?showAll=${showAll}&page=${
                        page + 1
                      }&filterText=${filterText}&startDate=${startDate}&endDate=${endDate}`
                    );
                  }}
                >
                  <ArrowForwardIcon />
                </Button>
              </div>
            }
          
            <div
              className={mobile ? filterDrawerOpen ? "mounted" : "unmounted" : undefined}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: mobile ? "100%" : undefined,
                justifyContent: mobile ? "center" : undefined,
              }}
            >
              <p style={{ margin: 0, padding: 0, color: "#077F8E" }}>
                Start Date
              </p>
              <input
                type="date"
                onChange={(e) => {
                  console.log(e.target.value);
                  setStartDate(e.target.value);
                  navigate(
                    `/jobs?showAll=${showAll}&page=${page}&filterText=${filterText}&startDate=${e.target.value}&endDate=${endDate}`
                  );
                }}
                style={styles.filterDate}
              />
              <p style={{ margin: 0, padding: 0, color: "#077F8E" }}>
                End Date
              </p>
              <input
                type="date"
                onChange={(e) => {
                  console.log(e.target.value);
                  setEndDate(e.target.value);
                  navigate(
                    `/jobs?showAll=${showAll}&page=${page}&filterText=${filterText}&startDate=${startDate}&endDate=${e.target.value}`
                  );
                }}
                style={styles.filterDate}
              />
            </div>

            <div 
              className={mobile ? filterDrawerOpen ? "mounted mobileMaxWidth" : "unmounted mobileMaxWidth" : undefined}
            >
              <Select
                variant="standard"
                sx={{ m: 1, minWidth: 120 }}
                // style={styles.select}
                value={Filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                {["Filter by text", "Filter by feedback", "Filter by risk"].map((key, index) => (
                  <MenuItem key={index} value={key}>
                    {key}
                  </MenuItem>
                ))}
              </Select>
              <input
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    if (Filter == "Filter by text") {
                      setFilterText(e.target.value);
                      setFilterFeedbackText("");
                      setFilterRiskText("");
                      navigate(
                        `/jobs?showAll=${showAll}&page=${page}&filterText=${e.target.value}&startDate=${startDate}&endDate=${endDate}`
                      );
                    } else if(Filter == "Filter by feedback") {
                      setFilterFeedbackText(e.target.value);
                      setFilterText("");
                      setFilterRiskText("");
                      navigate(
                        `/jobs?showAll=${showAll}&page=${page}&filterFeedbackText=${e.target.value}&startDate=${startDate}&endDate=${endDate}`
                      );
                    }
                    else if (Filter == "Filter by risk") {
                      setFilterFeedbackText("");
                      setFilterText("");
                      setFilterRiskText(e.target.value);
                      navigate(
                        `/jobs?showAll=${showAll}&page=${page}&filterRiskText=${e.target.value}&startDate=${startDate}&endDate=${endDate}`
                      );
                    }
                  }
                }}
                ref={(ref) => {
                  inputRef = ref;
                }}
                placeholder="Filter Jobs"
                className={mobile ? "mobileInputWidth" : undefined}
              />
              <Button
                variant="text"
                onClick={() => {
                  console.log(inputRef.value, "value");
                  searchquery(inputRef.value);
                }}
              >
                <SearchIcon />
              </Button>
            </div>
          </div>
          {mobile &&
            <Button
              className={mobile ? filterDrawerOpen ? "mounted" : "unmounted" : undefined}
              variant="contained"
              style={{
                backgroundColor: "#077F8E",
                color: "#fff",
                marginBlock: "10px",
              }}
              onClick={() => {
                navigate("/admin/upload");
              }}
            >
              Upload New Job
            </Button>
          }
          {mobile ? (
            <div
              style={{
                overflowX: "scroll",
                width: "100%",
                height: "100%",
              }}
            >
              <Entries
                jobs={jobs}
                center={center}
                statusObj={admin ? styles.statusObjAdmin : styles.statusObj}
                isAdmin={admin}
                baseURLAPI={baseURLAPI}
                imgSrc={imgSrc}
                refreshImage={refreshImage}
                baseURL={baseURL}
                setToastMessage={setToastMessage}
                setToastOpen={setToastOpen}
                setToastAnchorEl={setToastAnchorEl}
                getConfigs={getConfigs}
                setJobId={setJobId}
                setFeedbackModalOpen={setFeedbackModalOpen}
                setFeedbacks={setFeedbacks}
                setWarningsOpen={setWarningsOpen}
                setErrorsOpen={setErrorsOpen}
                setUpdatedJob={setUpdatedJob}
                setEditModalOpen={setEditModalOpen}
                setDeleteJob={setDeleteJob}
                setDeleteModalOpen={setDeleteModalOpen}
                setStopJob={setStopJob}
                setStopModalOpen={setStopModalOpen}
                mobile={mobile}
                setMetadata={setMetadata}
                sequence={sequence}
                setSequence={setSequence}
                setSelectedSequence={setSelectedSequence}
                sequencesModalOpen={sequencesModalOpen}
                setSequencesModalOpen={setSequencesModalOpen}
              />
            </div>
          ) : (
            <div className="table-wrapper">
              <Table id="jobsTable" style={styles.table(window.innerHeight)}>
                <TableHead>
                  <TableRow style={{ background: "#077F8E" }}>
                    <th
                      style={{
                        ...styles.smallWidth,
                        ...styles.tableHeaderItem,
                      }}
                    >
                      Sent to Ref. Dr.
                    </th>
                    <th style={styles.tableHeaderItem}>Job ID</th>
                    <th style={styles.tableHeaderItem}>From</th>
                    <th style={styles.tableHeaderItem}>Patient ID</th>
                    <th style={styles.tableHeaderItem}>Patient Name</th>
                    {center === "aster" ? (
                      <>
                        <th style={styles.tableHeaderItem}>Study ID</th>
                        <th style={styles.tableHeaderItem}>Accession Number</th>
                      </>
                    ) : null}
                    <th style={styles.tableHeaderItem}>Status</th>
                    {admin ?
                      <th style={styles.tableHeaderItem}>Client Status</th>
                      : null
                    }
                    <th style={styles.tableHeaderItem}>Recieved At</th>
                    <th style={styles.tableHeaderItem}>Completed At</th>
                    {admin ? (
                      <th style={styles.tableHeaderItem}>Verified At</th>
                    ) : null}
                    {admin ? (
                      <th style={styles.tableHeaderItem}>Sequences</th>
                    ) : null}
                    {admin || center == "cect" ? (
                      <th style={styles.tableHeaderItem}>View</th>
                    ) : null}
                     {/* {admin ? (  */}
                      <th style={styles.tableHeaderItem}>Annotate</th>
                     {/* ) : null} */}
                    <th style={styles.tableHeaderItem}>Report</th>
                    {/* <th style={styles.tableHeaderItem}>3D</th> */}
                    {admin ? (
                      <th style={styles.tableHeaderItem}>Feedback</th>
                    ) : null}
                      {admin ? (
                      <th style={styles.tableHeaderItem}>Paid</th>
                    ) : null}
                    <th style={styles.tableHeaderItem}>Risk Level</th>
                    {admin ? (
                      <th style={styles.tableHeaderItem}>Warnings</th>
                    ) : null}
                    {/* {admin ? ( */}
                      <th style={styles.tableHeaderItem}>Actions</th>
                    {/* ) : null} */}

                    {/* {admin && <th style={styles.tableHeaderItem}>Qc user</th>} */}

                  </TableRow>
                </TableHead>

                <TableBody>
                  {jobs.map((job) => (
                    <tr
                      key={job.jobId}
                      style={styles.tableRow(job.status, job.findings, job.approvedCacScore)}
                      className="tableRow-3d"
                    >
                      <td style={styles.smallWidth}>
                        <Checkbox
                          checked={job.sentToReferring === "yes"}
                          // style={{
                          //     color: job.sentToReferring === 'yes' ? '#077F8E' : 'white',
                          // }}
                          onChange={(e) => {
                            console.log(e);
                            const formData = new FormData();
                            formData.append("job_id", job.jobId);
                            formData.append(
                              "update_key",
                              "sent_to_referring_doctor"
                            );
                            // formData.append('update_val', 'yes');
                            formData.append(
                              "update_val",
                              e.target.checked ? "yes" : "no"
                            );
                            axios({
                              method: "POST",
                              url: `${baseURLAPI}/job_update`,
                              data: formData,
                            })
                              .then((res) => {
                                console.log("updated....", res);
                                // getData();
                                setJobUpdated(
                                  (prevJobUpdated) => prevJobUpdated + 1
                                );
                              })
                              .catch((err) => {
                                console.log("error: ", err);
                              });
                          }}
                        />
                      </td>
                      {/* <td style={styles.tableBodyItem}>{job.jobId}</td> */}
                      <td
                        style={styles.tableBodyItem}
                        onMouseOver={(e) => {
                          e.target.style.cursor = "pointer";
                          e.target.title = job.jobId;
                        }}
                        onClick={(e) => {
                          navigator.clipboard.writeText(job.jobId);
                          setToastMessage("Job ID copied to clipboard");
                          setToastOpen(true);
                          setToastPlacement("right-end");
                          setToastAnchorEl(e.target);
                          setTimeout(() => {
                            setToastOpen(false);
                            setToastMessage("");
                            setToastPlacement("");
                          }, 2000);
                        }}
                      >
                        {/* // show only 8 characters of job id */}
                        {job.jobId.substring(0, 8)}
                      </td>
                      <td style={styles.tableBodyItem}>{job.dataFrom}</td>
                      <td style={styles.tableBodyItem}>{job.patientId}</td>
                      <td style={styles.tableBodyItem}>{job.patientName} {job.patientAge}/{job.patientGender}</td>
                      {center === "aster" ? (
                        <>
                          <td
                            style={styles.tableBodyItem}
                            onMouseOver={(e) => {
                              e.target.style.cursor = "pointer";
                              e.target.title = job.studyId;
                            }}
                            onClick={(e) => {
                              navigator.clipboard.writeText(job.studyId);
                              setToastMessage("Study ID copied to clipboard");
                              setToastOpen(true);
                              setToastPlacement("right-end");
                              setToastAnchorEl(e.target);
                              setTimeout(() => {
                                setToastOpen(false);
                                setToastMessage("");
                                setToastPlacement("");
                              }, 2000);
                            }}
                          >
                            {job.studyId.substring(0, 16)}
                          </td>
                          <td style={styles.tableBodyItem}>
                            {job.accessionNumber}
                          </td>
                        </>
                      ) : null}
                      <td style={styles.tableBodyItem}>
                        {admin ? (
                          <Status
                            status={job.status}
                            statusObj={styles.statusObjAdmin}
                          />
                        ) : (
                          <Status
                            status={
                              job.reportStatus ||
                              (job.status.toLowerCase() === "queued" &&
                                job.status) ||
                              (job.status.toLowerCase() === "failed" &&
                                job.status) ||
                              "Processing"
                            }
                            statusObj={styles.statusObj}
                          />
                        )}
                      </td>
                      {admin ?
                        <td style={styles.tableBodyItem}>
                          {
                            <Status
                              status={
                                job.reportStatus ||
                                (job.status.toLowerCase() === "queued" &&
                                  job.status) ||
                                (job.status.toLowerCase() === "failed" &&
                                  job.status) ||
                                "Processing"
                              }
                              statusObj={styles.statusObj}
                            />
                          }
                        </td>
                      : null }
                      <td style={styles.tableBodyItem}>
                        {new Date(job.receivedAt).toLocaleString("en-IN", {
                          timeZone: "Asia/Kolkata",
                          hour12: false,
                        })}
                      </td>
                      <td style={styles.tableBodyItem}>
                        {admin
                          ? job.completedAt === null
                            ? "NA"
                            : new Date(job.completedAt).toLocaleString(
                                "en-IN",
                                { timeZone: "Asia/Kolkata", hour12: false }
                              )
                          : job.verifiedAt != null
                          ? new Date(job.verifiedAt).toLocaleString("en-IN", {
                              timeZone: "Asia/Kolkata",
                              hour12: false,
                            })
                          : "NA"}
                      </td>
                      {admin ? (
                        <td style={styles.tableBodyItem}>
                          {job.verifiedAt != null
                            ? new Date(job.verifiedAt).toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                                hour12: false,
                              })
                            : "NA"}
                        </td>
                      ) : null}
                      {admin ? (
                        <td style={styles.tableBodyItem}>
                          <VisibilityIcon
                            style={{
                              fill: "#077F8E",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              axios
                                .get(
                                  `${baseURLAPI}/admin/job_sequences/${job.jobId}`,
                                  {
                                    headers: {
                                      Authorization: "Bearer " + token,
                                    },
                                  }
                                )
                                .then((res) => {
                                  const response = res.data;
                                  console.log("response", response);
                                  setMetadata(response.metadata);
                                  setSequence(response.selected_sequence);
                                  setSelectedSequence(
                                    response.selected_sequence
                                  );
                                  setJobId(job.jobId);
                                  refreshImage(
                                    job.jobId,
                                    response.selected_sequence
                                  );
                                })
                                .catch((err) => {
                                  console.log(err);
                                });

                              setSequencesModalOpen(true);
                            }}
                          />
                        </td>
                      ) : null}
                      {admin || center == "cect" ? (
                        <td style={styles.tableBodyItem}>
                          <OpenInNewIcon
                            style={{
                              fill: "#077F8E",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              // first get viewer token
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              axios
                                .get(`${baseURLAPI}/viewer-token/make`, {
                                  headers: {
                                    Authorization: "Bearer " + token,
                                  },
                                })
                                .then((res) => {
                                  const response = res.data;
                                  console.log("response", response);
                                  // then open viewer

                                  let link = document.createElement("a");
                                  // let url = `https://urologic.biocliq.ai/aarthi/ohif_viewer/viewer/${job.studyId}`;
                                  // console.log("ohifURL: ", ohifURL)
                                  // let url = `${ohifURL}/${job.studyId}`;
                                  let url = `https://cac-test.urologiq.ai/viewer/${job.studyId}?center=${center}&viewerToken=${response.token}`;
                                  link.href = url;
                                  link.click();
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }}
                          />
                        </td>
                      ) : null}

                    {(!admin && (job.reportStatus === false || job.reportStatus === "processing" || job.reportStatus === "Processing")) ?
                      <td></td>
                    :
                      <td style={styles.tableBodyItem}>
                        <OpenInNewIcon
                          style={{
                            fill: "#077F8E",
                            cursor: "pointer",
                            // opacity: !admin && (job.reportStatus === "verified" || job.reportStatus === "accepted" || job.reportStatus === "rejected") ? 0.5 : 1,
                          }}
                          onClick={() => {
                            if(admin)
                              navigate(`/view/${job.jobId}`);
                            else
                              window.open(`/dashboard/view/${job.jobId}`, '_blank');
                          }}
                        />
                      </td>
                    }

                        <Report
                          job={job}
                          admin={admin}
                          center={center}
                          setReportModalOpen={setReportModalOpen}
                          setReportModalOpen2={setReportModalOpen2}
                          setOpenJobID={setOpenJobID}
                          onSummarizeClick={() => {
                            setJobId(job.jobId);
                            const token = admin
                              ? localStorage.getItem(`token-${center}`)
                              : localStorage.getItem("token");
                            getConfigs(job.jobId);
                          }}
                          onMergeClick={() => {
                            setJobId(job.jobId);
                            setMergeModal(true);
                          }}
                          onSaveClick={() => {
                            if (!admin && job.reportStatus === "verified") return; 
                            const token = admin
                              ? localStorage.getItem(`token-${center}`)
                              : localStorage.getItem("token");

                            axios({
                              method: "GET",
                              url: `${baseURL}/report/${job.jobId}`,
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                              responseType: "arraybuffer",
                            })
                              .then((res) => {
                                // download file
                                console.log("res", res);
                                let blob = new Blob([res.data], {
                                  type: "application/pdf",
                                });
                                let url = window.URL.createObjectURL(blob);
                                let link = document.createElement("a");
                                link.href = url;
                                link.download = `${job.patientName}.pdf`;
                                link.click();
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                          onGetMergeClick={() => {
                            const token = admin
                              ? localStorage.getItem(`token-${center}`)
                              : localStorage.getItem("token");

                            axios({
                              method: "GET",
                              url: `${baseURL}/report_merged/${job.jobId}`,
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                              responseType: "arraybuffer",
                            })
                              .then((res) => {
                                // download file
                                console.log("res", res);
                                let blob = new Blob([res.data], {
                                  type: "application/pdf",
                                });
                                let url = window.URL.createObjectURL(blob);
                                let link = document.createElement("a");
                                link.href = url;
                                link.download = `${job.patientName}.pdf`;
                                link.click();
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                          sendWhatsapp={() => {
                            const token = admin
                              ? localStorage.getItem(`token-${center}`)
                              : localStorage.getItem("token");
                            const data = {
                              job_id: job.jobId,
                            };
                            axios
                              .post(baseURLAPI + "/send_report_cect", data, {
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                },
                              })
                              .then((res) => {
                                setShowAll(!showAll);
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                        />

                      {/* <td style={styles.tableBodyItem}>
                        {admin || job.reportStatus === "completed" ? (
                          <Link
                            to={`/render/${job.jobId}`}
                            style={{
                              display: "flex",
                              height: "100%",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                            }}
                            // state={{
                            //     patientName: job.patientName,
                            // }}
                          >
                            <ViewInArIcon style={{ fill: "#077F8E" }} />
                            {admin ? (
                              <span style={styles.badge}>{job.qrVisitors}</span>
                            ) : null}
                          </Link>
                        ) : null}
                      </td> */}
                      {admin && 
                        <td style={styles.tableBodyItem}>
                          <Button
                            onClick={() => {
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              axios
                                .get(
                                  `${baseURLAPI}/feedback?job_id=${job.jobId}`,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                )
                                .then((res) => {
                                  console.log("feedbacks", res);
                                  setFeedbacks(res.data.feedback);
                                  setFeedbackModalOpen(true);
                                  setJobId(job.jobId);
                                })
                                .catch((err) => {
                                  console.log("err", err);
                                });
                            }}
                          >
                            <CommentIcon style={{color:"#077F8E"}} />
                          </Button>
                        </td>
                      }
                      {admin && (
                        <td style={styles.tableBodyItem}>
                          {job.paid ? <CheckCircleOutline/> : "-"}
                        </td>
                      )}
                      {admin ?
                        <td style={styles.tableBodyItem}>
                          { 
                            job.status != "Finished" && job.status != "Completed" ? "-"
                            :
                            job.approvedCacScore<=10 && job.approvedCacScore>=0 ? "Nill"
                            :
                            job.approvedCacScore>10 && job.approvedCacScore<=100 ? "Mild"
                            :
                            job.approvedCacScore>100 && job.approvedCacScore<=400 ? "Moderate"
                            :
                            "High"
                          }
                        </td>
                        :
                        <td style={styles.tableBodyItem}>
                          {
                            job.reportStatus === 'completed' || job.reportStatus === 'verified' || job.reportStatus === 'accepted' || job.reportStatus === 'rejected' ?
                            (
                            job.approvedCacScore<=10 && job.approvedCacScore>=0 ? "Nill"
                            :
                            job.approvedCacScore>10 && job.approvedCacScore<=100 ? "Mild"
                            :
                            job.approvedCacScore>100 && job.approvedCacScore<=400 ? "Moderate"
                            :
                            "High") : "-"
                          }
                        </td>
                      }

                      {/* Warnings */}
                      {admin ? (
                        <td
                          style={styles.tableBodyItem}
                          onMouseOver={(e) => {
                            if(errorsOpen) return;
                            // console.log("job status", job.status);
                            if (job.status === "Finished") {
                              if (
                                Object.values(job.warnings || {}).reduce(
                                  (a, b) => a + b.length,
                                  0
                                ) > 0
                              ) {
                                setJobId(job.jobId);
                                setToastMessage(job.warnings);
                                setWarningsOpen(true);
                                setToastAnchorEl(e.currentTarget);
                                setTimeout(() => {
                                  setWarningsOpen(false);
                                  setToastMessage("");
                                }, 2000);
                              }
                              console.log("no warnings");
                            } else if(job.status === "Failed") {
                              // set cursor to pointer
                              e.currentTarget.style.cursor = "pointer";
                              console.log("getting errors");
                              const target = e.currentTarget;
                              // get errors from server
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              axios
                                .get(
                                  `${baseURLAPI}/errors?job_id=${job.jobId}`,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                )
                                .then((res) => {
                                  console.log(res.data.errors, "errors");
                                  setJobId(job.jobId);
                                  setErrorsOpen(true);
                                  setToastMessage(res.data.errors);
                                  console.log(
                                    e.currentTarget,
                                    "current target"
                                  );
                                  setToastAnchorEl(target);
                                  setTimeout(() => {
                                    setErrorsOpen(false);
                                    setToastMessage("");
                                  }, 2000);
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }
                            else{
                              e.currentTarget.style.cursor = "not-allowed";
                              console.log("no errors");
                            }
                          }}
                          onClick={(e) => {
                            if (job.status === "Failed") {
                              // download log file
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              axios({
                                method: "GET",
                                url: `${baseURLAPI}/log?job_id=${job.jobId}`,
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                },
                                // responseType: "arraybuffer",
                              })
                                .then((res) => {
                                  // download file
                                  console.log("res", res);

                                  let blob = new Blob([res.data], {
                                    type: "text/plain",
                                  });
                                  let url = window.URL.createObjectURL(blob);
                                  let link = document.createElement("a");

                                  link.href = url;
                                  link.download = `${job.jobId}.log`;
                                  link.click();
                                })
                                .catch((err) => {
                                  console.log("err", err);
                                });
                            }
                          }}
                        >
                          {job.status === "Finished"
                            ? Object.values(job.warnings || {}).reduce(
                                (a, b) => a + b.length,
                                0
                              )
                            : null}
                          {job.status === "Failed" ? (
                            <ErrorIcon style={{ fill: "#077F8E" }} />
                          ) : null}
                        </td>
                      ) : null}

                      {/* Actions */}
                      {admin ? (
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            maxHeight: "30px",
                            borderWidth: "0px",
                            borderStyle: "none",
                            padding: "3px",
                            minWidth: "80px",
                          }}
                        >
                          <EditIcon
                            style={{ color: "green", cursor: "pointer" }}
                            onClick={() => {
                              console.log("edit job", job);
                              setUpdatedJob(job);
                              setEditModalOpen(true);
                            }}
                          />

                          <DeleteForever
                            style={{ color: "red", cursor: "pointer" }}
                            onClick={() => {
                              setDeleteJob(job);
                              setDeleteModalOpen(true);
                            }}
                          />
                          {job.status != "finished" && (
                            <StopCircleIcon
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={() => {
                                setStopJob(job);
                                setStopModalOpen(true);
                              }}
                            />
                          )}
                        </td>
                      ) : 
                        <td 
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            borderWidth: "0px",
                            borderStyle: "none",
                            padding: "3px",
                            minWidth: "80px",
                            height: "43px",
                          }}  
                        >
                          {(job.reportStatus !== "Processing" && job.reportStatus !== "processing" && job.reportStatus !== false) ?
                            <Tooltip title="Accept">
                              <ThumbUpIcon 
                              style={{ 
                                color: "green", 
                                cursor: "pointer", 
                                opacity: (job.reportStatus === "completed" || job.reportStatus === "accepted" || job.reportStatus === "rejected" ) ? 0.3 : 1
                              }}
                                onClick={(e) => {
                                  if(job.reportStatus === "completed" || job.reportStatus === "accepted" || job.reportStatus === "rejected"){
                                    // alert("Sorry, you cannot accept the report now as it is already completed");
                                    return;
                                  }
                                  const token = admin
                                    ? localStorage.getItem(`token-${center}`)
                                    : localStorage.getItem("token");
                                  const data = {
                                    job_id: job.jobId,
                                    // config_name: config.config,
                                  };
                                  axios
                                    .post(baseURLAPI + "/accept_report", data, {
                                      headers: {
                                        Authorization: `Bearer ${token}`,
                                      },
                                    })
                                    .then((res) => {
                                      console.log(res);
                                      setToastMessage("Report Accepted");
                                      // alert("Report Accepted"); 
                                      setToastOpen(true);
                                      setToastAnchorEl(e.currentTarget);
                                      setTimeout(() => {
                                        setToastOpen(false);
                                      }, 2000);
                                      // getConfigs(job.jobId);
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                }}
                              />
                            </Tooltip>
                            : null
                          }

                          {(job.reportStatus !== "Processing" && job.reportStatus !== "processing" && job.reportStatus !== false) ?
                            <Tooltip title="Reject">
                              <ThumbDownIcon 
                                style={{ 
                                  color: "red", 
                                  cursor: "pointer", 
                                  opacity: (job.reportStatus === "completed" || job.reportStatus === "accepted" || job.reportStatus === "rejected" ) ? 0.3 : 1
                                }}
                                onClick={(e) => {
                                  if(job.reportStatus === "completed" || job.reportStatus === "accepted" || job.reportStatus === "rejected"){
                                    // alert("Sorry, you cannot accept the report now as it is already completed");
                                    return;
                                  }
                                  const token = admin
                                    ? localStorage.getItem(`token-${center}`)
                                    : localStorage.getItem("token");
                                  const data = {
                                    job_id: job.jobId,
                                    // config_name: config.config,
                                  };
                                  axios
                                    .post(baseURLAPI + "/reject_report", data, {
                                      headers: {
                                        Authorization: `Bearer ${token}`,
                                      },
                                    })
                                    .then((res) => {
                                      console.log(res);
                                      setToastMessage("Report Rejected");
                                      // alert("Report Rejected"); 
                                      setToastOpen(true);
                                      setToastAnchorEl(e.currentTarget);
                                      setTimeout(() => {
                                        setToastOpen(false);
                                      }, 2000);
                                      // getConfigs(job.jobId);
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                }}
                                /> 
                            </Tooltip> 
                            : null
                          }
                        </td>
                      }
                      {/* {admin ? <td>{job.qc_user.split("@")[0]}</td> : null} */}
                    </tr>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
          {loading ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress
                style={{ color: "#077F8E", margin: "auto", marginTop: "100px" }}
              />
            </div>
          ) : null}
          <Modal
            open={feedbackModalOpen}
            onClose={() => {
              setFeedbackModalOpen(false);
              setNewFeedback("");
            }}
          >
            <div style={mobile ? styles.feedbackModalMobile : styles.feedbackModal}>
              Feedbacks
              {feedbacks?.length > 0 ? (
                <div style={{ width: "100%", height: "70%" }}>
                  {feedbacks?.length} feedbacks found
                  <div className="feedbacks">
                    {feedbacks?.map((feedback, index) => {
                      return (
                        <Feedback
                          key={index}
                          index={index + 1}
                          feedback={feedback.feedback}
                          feedbackBy={feedback.feedbackBy}
                          feedbackDate={feedback.feedbackDate}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                <p>No feedbacks found</p>
              )}
              <Select
                closeMenuOnSelect={false}
                style={{
                  width: "300px",
                  marginLeft: "10px",
                  marginRight: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  height: "50px"
                }}
                // components={animatedComponents}
                value={feedbackSelected}
                renderValue={(selected) => {
                  console.log(selected);
                  if (selected.length === 0) {
                    return <em>Select feedback</em>;
                  }
                  return selected.join(", ");
                }}
                multiple
                options={feedbackValues}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 48 * 4.5 + 8,
                      width: 1000
                    }
                  }
                }}
              >
                <MenuItem value="all" sx={{ display: "inline-flex", width: "33%" }}>
                  <ListItemIcon>
                    <Checkbox
                      checked={
                        feedbackValues.length === feedbackSelected.length
                      }
                      onChange={(e) => {
                        console.log(e, "clicked icon");
                        e.stopPropagation();
                        if (feedbackSelected.length === feedbackValues.length) {
                          // remove all from selected
                          setfeedbackSelected([]);
                        } else {
                          setfeedbackSelected(feedbackValues);
                        }
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="all" />
                </MenuItem>
                {feedbackValues.map((center, index) => {
                  return (
                    <MenuItem key={index} value={center} sx={{ display: "inline-flex", width: "33%" }}>
                      <ListItemIcon>
                        <Checkbox
                          checked={
                            feedbackSelected.indexOf(center) > -1 ||
                            feedbackSelected.indexOf("all") > -1
                          }
                          onChange={(e) => {
                            console.log(e, "clicked icon");
                            e.stopPropagation();
                            if (
                              feedbackSelected.length ===
                                JSON.parse(localStorage.getItem("centers")).length ||
                              feedbackSelected.indexOf("all") > -1
                            ) {
                              // remove all from selected
                              let newfeedbackSelected = feedbackValues.filter(
                                (c) => c !== center
                              );
                              setfeedbackSelected(newfeedbackSelected);
                            } else {
                              // check if center is already selected
                              if (feedbackSelected.indexOf(center) > -1) {
                                let newfeedbackSelected =
                                  feedbackSelected.filter((c) => c !== center);
                                setfeedbackSelected(newfeedbackSelected);
                              } // add center to selected
                              else
                                setfeedbackSelected([
                                  ...feedbackSelected,
                                  center,
                                ]);
                            }
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={center} />
                    </MenuItem>
                  );
                })}
              </Select>
              {/* <Select
                style={styles.select}
                value={newFeedback}
                onChange={(e) => setNewFeedback(e.target.value)}
              >
                {[
                   "Stent",
                   "Normal",
                   "Abnormal",
                   "Aortic Calcifications",
                   "Artifacts",
                   "Valve Calcifications",
                   "FP"
                ].map((key, index) => (
                  <MenuItem key={index} value={key}>
                    {key}
                  </MenuItem>
                ))}
              </Select> */}
              <TextField
                style={{
                  width:"300px"
                }}
                label="feedback"
                value={feedbackSelected.join(",")}
                onChange={(e) => setfeedbackSelected(e.target.value.split(","))}
              ></TextField>
              <Button
                onClick={() => {
                  const token = admin
                    ? localStorage.getItem(`token-${center}`)
                    : localStorage.getItem("token");
                  axios
                    .post(
                      `${baseURLAPI}/feedback`,
                      {
                        job_id: jobId,
                        feedback: feedbackSelected.join(","),
                        // email: props.currentUser.email,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    )
                    .then((res) => {
                      console.log("res", res);
                      axios
                        .get(`${baseURLAPI}/feedback?job_id=${jobId}`, {
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                        })
                        .then((res) => {
                          console.log("feedbacks", res);
                          setFeedbacks(res.data.feedback);
                        })
                        .catch((err) => {
                          console.log("err", err);
                        });
                    })
                    .catch((err) => {
                      console.log("err", err);
                    }).finally(()=>{
                      setfeedbackSelected([])
                    });
                }}
              >
                Add
              </Button>
            </div>
          </Modal>
          <Modal
            open={editModalOpen}
            onClose={() => {
              setEditModalOpen(false);
            }}
          >
            <div style={mobile ? styles.modalMobile : styles.modal}>
              <h3>Update Job</h3>
              <div style={styles.modalBody}>
                <div style={styles.modalBodyItem}>
                  <label>Job Id</label>
                  <input type="text" value={jobId} disabled />
                </div>
                <div style={styles.modalBodyItem}>
                  <label>Patient Id</label>
                  <input
                    type="text"
                    value={updatedJob.patientId}
                    onChange={(e) => {
                      setUpdatedJob((prevUpdatedJob) => {
                        return {
                          ...prevUpdatedJob,
                          patientId: e.target.value,
                        };
                      });
                    }}
                  />
                </div>
                <div style={styles.modalBodyItem}>
                  <label>Patient Name</label>
                  <input
                    type="text"
                    value={updatedJob.patientName}
                    onChange={(e) => {
                      setUpdatedJob((prevUpdatedJob) => {
                        return {
                          ...prevUpdatedJob,
                          patientName: e.target.value,
                        };
                      });
                    }}
                  />
                </div>
                <div style={styles.modalBodyItem}>
                  <label>Status</label>
                  <input
                    value={updatedJob.status}
                    onChange={(e) => {
                      setUpdatedJob((prevUpdatedJob) => {
                        return {
                          ...prevUpdatedJob,
                          status: e.target.value,
                        };
                      });
                    }}
                  />
                </div>
                <div style={styles.modalBodyItem}>
                  <label>Received At</label>
                  <input
                    type="datetime-local"
                    value={updatedJob.receivedAt}
                    onChange={(e) => {
                      setUpdatedJob((prevUpdatedJob) => {
                        return {
                          ...prevUpdatedJob,
                          receivedAt: new Date(e.target.value).toUTCString(),
                        };
                      });
                    }}
                  />
                </div>
                <div style={styles.modalBodyItem}>
                  <label>Completed At</label>
                  <input
                    type="datetime-local"
                    value={updatedJob.completedAt}
                    onChange={(e) => {
                      setUpdatedJob((prevUpdatedJob) => {
                        return {
                          ...prevUpdatedJob,
                          completedAt: new Date(e.target.value).toUTCString(),
                        };
                      });
                    }}
                  />
                </div>

                <Button
                  onClick={() => {
                    const formData = new FormData();
                    formData.append("job_id", updatedJob.jobId);
                    formData.append("patient_id", updatedJob.patientId);
                    formData.append("patient_name", updatedJob.patientName);
                    formData.append("status", updatedJob.status);
                    formData.append("received_at", updatedJob.receivedAt);
                    formData.append("completed_at", updatedJob.completedAt);
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");
                    axios
                      .post(`${baseURLAPI}/admin/job_update`, formData, {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      })
                      .then((res) => {
                        console.log(res);
                        setJobUpdated((prevJobUpdated) => prevJobUpdated + 1);
                        setEditModalOpen(false);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                  style={styles.modalButton}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal>
          <Modal
            open={stopModalOpen}
            onClose={() => {
              setStopModalOpen(false);
            }}
          >
            <div style={mobile ? styles.deleteModalMobile : styles.deleteModal}>
              <h3>Stop Job</h3>
              <div style={styles.modalBody}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <label style={{ fontWeight: "700", fontSize: "14pt" }}>
                    Are you sure you want to stop this job?
                  </label>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      width: "98%",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "700",
                          marginRight: "5px",
                        }}
                      >
                        Job Id :{" "}
                      </label>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "400",
                        }}
                      >
                        {stopJob.jobId}
                      </label>
                    </div>
                    <div>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "700",
                          marginRight: "5px",
                        }}
                      >
                        Patient Id :{" "}
                      </label>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "400",
                        }}
                      >
                        {stopJob.patientId}
                      </label>
                    </div>
                    <div>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "700",
                          marginRight: "5px",
                        }}
                      >
                        Patient Name :{" "}
                      </label>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "400",
                        }}
                      >
                        {stopJob.patientName}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexDirection: "row",
                  width: "96%",
                }}
              >
                <Button
                  onClick={() => {
                    console.log("Stop job");
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");
                    axios
                      .get(`${baseURLAPI}/admin/stop/${stopJob.jobId}`, {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      })
                      .then((res) => {
                        console.log(res);

                        setStopJob((prevStopJob) => {
                          return {
                            ...prevStopJob,
                            status: res.data.status,
                          };
                        });

                        // setJobUpdated((prevJobUpdated) => prevJobUpdated + 1);
                      })
                      .catch((err) => {
                        console.log(err);
                      })
                      .finally(() => {
                        setStopModalOpen(false);
                      });
                  }}
                  style={{
                    ...styles.modalButton,
                    backgroundColor: "red",
                    marginRight: "5px",
                  }}
                >
                  Stop
                </Button>
                <Button
                  style={{ ...styles.modalButton, backgroundColor: "green" }}
                  onClick={() => {
                    setStopModalOpen(false);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Modal>
          <Modal
            open={deleteModalOpen}
            onClose={() => {
              setDeleteModalOpen(false);
            }}
          >
            <div style={mobile ? styles.deleteModalMobile : styles.deleteModal}>
              <h3>Delete Job</h3>
              <div style={styles.modalBody}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <label style={{ fontWeight: "700", fontSize: "14pt" }}>
                    Are you sure you want to delete this job?
                  </label>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      width: "98%",
                    }}
                  >
                    <div>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "700",
                          marginRight: "5px",
                        }}
                      >
                        Job Id :{" "}
                      </label>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "400",
                        }}
                      >
                        {deleteJob.jobId}
                      </label>
                    </div>
                    <div>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "700",
                          marginRight: "5px",
                        }}
                      >
                        Patient Id :{" "}
                      </label>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "400",
                        }}
                      >
                        {deleteJob.patientId}
                      </label>
                    </div>
                    <div>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "700",
                          marginRight: "5px",
                        }}
                      >
                        Patient Name :{" "}
                      </label>
                      <label
                        style={{
                          margin: "0",
                          fontSize: "12pt",
                          fontWeight: "400",
                        }}
                      >
                        {deleteJob.patientName}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexDirection: "row",
                  width: "96%",
                }}
              >
                <Button
                  onClick={() => {
                    console.log("delete job");
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");
                    const formData = new FormData();
                    formData.append("job_id", deleteJob.jobId);
                    axios
                      .post(`${baseURLAPI}/admin/job_delete`, formData, {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      })
                      .then((res) => {
                        console.log(res);
                        setJobUpdated((prevJobUpdated) => prevJobUpdated + 1);
                      })
                      .catch((err) => {
                        console.log(err);
                      })
                      .finally(() => {
                        setDeleteModalOpen(false);
                      });
                  }}
                  style={{
                    ...styles.modalButton,
                    backgroundColor: "red",
                    marginRight: "5px",
                  }}
                >
                  Delete
                </Button>
                <Button
                  style={{ ...styles.modalButton, backgroundColor: "green" }}
                  onClick={() => {
                    setDeleteModalOpen(false);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Modal>
          <Modal
            open={sequencesModalOpen}
            onClose={() => {
              setSequence("");
              setSequencesModalOpen(false);
            }}
          >
            {sequence !== "" && sequence in metadata ? (
              <div style={mobile ? styles.sequencesModalMobile : styles.sequencesModal}>
                <div style={styles.sequencesModalRow}>
                  <p
                    style={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "bold",
                      marginBottom: mobile ? "1px" : "10px",
                      marginLeft: mobile ? undefined : "20%",
                    }}
                  >
                    Sequence:{" "}
                  </p>
                  <Select
                    style={mobile ? styles.selectMobile : styles.select}
                    value={sequence}
                    onChange={(e) => {
                      setSequence(e.target.value);
                      refreshImage(jobId, e.target.value);
                    }}
                  >
                    {Object.keys(metadata).map((key, index) => (
                      <MenuItem key={index} value={key}>
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div style={styles.sequencesModalRow}>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginBottom: mobile ? "1px" : "10px",
                    }}
                  >
                    Slice Thickness
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      marginBottom: mobile ? "1px" : "10px",
                      marginLeft: "20px",
                    }}
                  >
                    {metadata[sequence].SliceThickness}
                  </p>
                </div>
                <div style={styles.sequencesModalRow}>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginBottom: mobile ? "1px" : "10px",
                    }}
                  >
                    Spacing Between Slices
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      marginBottom: mobile ? "1px" : "10px",
                      marginLeft: "20px",
                    }}
                  >
                    {metadata[sequence].SpacingBetweenSlices}
                  </p>
                </div>
                <div style={styles.sequencesModalRow}>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    Pixel Spacing
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      marginBottom: "10px",
                      marginLeft: "20px",
                    }}
                  >
                    {metadata[sequence].PixelSpacing}
                  </p>
                </div>
                <div style={styles.sequencesModalRow}>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginBottom: mobile ? "15px" : "10px",
                      color: "#1ba992",
                      cursor: "pointer",
                    }}
                  >
                    {sequence === selectedSequence ? "Used in report" : ""}
                  </p>
                  <Button
                    style={{
                      marginBottom: mobile ? "15px" : "10px",
                      width: "100px",
                      height: mobile ? "20px" : undefined,
                      fontSize : mobile && "13px",
                      backgroundColor: "#1ba992",
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      refreshImage(jobId, sequence);
                    }}
                  >
                    Refresh
                    <RefreshIcon style={{ marginLeft: "5px",  fontSize: mobile && "20px",  }} />
                  </Button>
                </div>
                <img src={imgSrc} className="sequencesImg" />
                <Button
                  style={{
                    marginTop: "10px",
                    width: mobile ? "70%" : "300px",
                    fontSize: mobile && "11px",
                    backgroundColor: "#089AAC",
                  }}
                  variant="contained"
                  onClick={(e) => {
                    const token = admin
                      ? localStorage.getItem(`token-${center}`)
                      : localStorage.getItem("token");
                    const formData = new FormData();
                    formData.append("job_id", jobId);
                    formData.append("sequence", sequence);
                    formData.append("run_again", "yes");
                    axios
                      .post(baseURL + "/trigger_pipeline", formData, {
                        headers: {
                          Authorization: "Bearer " + token,
                        },
                      })
                      .then((res) => {
                        console.log(res);
                        setToastMessage("Pipeline triggered");
                        setToastOpen(true);
                        setToastAnchorEl(e.currentTarget);
                        setTimeout(() => {
                          setToastOpen(false);
                        }, 2000);
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                >
                  Use this sequence for pipeline
                </Button>
              </div>
            ) : (
              <div style={styles.sequencesModal}>
                <CircularProgress />
              </div>
            )}
          </Modal>
          <Modal
            open={reportModalConfigOpen}
            onClose={() => {
              setReportModalConfigOpen(false);
            }}
          >
            <div style={mobile ? styles.reportModalConfigMobile : styles.reportModalConfig}>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <tr>
                  <th style={styles.reportTableHeaderItem}>Config</th>
                  <th style={styles.reportTableHeaderItem}>Actions</th>
                  <th style={styles.reportTableHeaderItem}>Sent</th>
                  <th style={styles.reportTableHeaderItem}>Config Time</th>
                </tr>
                {reportConfigs.map((config, index) => (
                  <tr key={index}>
                    <td style={styles.reportTableBodyItem}>{config.config}</td>
                    <td
                      style={styles.reportTableBodyItem}
                      className="rptModalAct"
                    >
                      <Tooltip title={`CAC Score: ${config.total_cac_score}`}>
                        <SaveIcon
                          style={{
                            fill: "#077F8E", // 1b4b84 design
                            cursor: "pointer",
                            padding: 0,
                          }}
                          onClick={() => {
                            const token = admin
                              ? localStorage.getItem(`token-${center}`)
                              : localStorage.getItem("token");
                            axios({
                              method: "GET",
                              url: `${baseURL}/report/${jobId}/${config.config}`,
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                              responseType: "arraybuffer",
                            })
                              .then((res) => {
                                // download file
                                console.log("res", res);
                                let blob = new Blob([res.data], {
                                  type: "application/pdf",
                                });
                                let url = window.URL.createObjectURL(blob);
                                let link = document.createElement("a");
                                link.href = url;
                                link.download = `${jobId}_${config.config}.pdf`;
                                link.click();
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          }}
                        />
                      </Tooltip>
                      <Link to={`/report/${jobId}`}>
                        <EditIcon
                          style={{
                            fill: "#077F8E",
                            cursor: "pointer",
                            padding: 0,
                          }}
                        />
                      </Link>
                      <DeleteForever
                        style={{
                          fill: "red",
                          cursor: "pointer",
                          padding: 0,
                        }}
                        onClick={(e) => {
                          const token = admin
                            ? localStorage.getItem(`token-${center}`)
                            : localStorage.getItem("token");
                          console.log("token", token);
                          const data = {
                            job_id: jobId,
                            config_name: config.config,
                          };
                          axios
                            .post(baseURLAPI + "/config", data, {
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                            })
                            .then((res) => {
                              console.log(res);
                              setToastMessage("Report deleted");
                              setToastOpen(true);
                              setToastAnchorEl(e.currentTarget);
                              setTimeout(() => {
                                setToastOpen(false);
                              }, 2000);
                              getConfigs(jobId);
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }}
                      />
                      {!config.verified ? (
                        <Tooltip title="Verify">
                          <NewReleasesIcon 
                            style={{
                              fill: "#077F8E",
                              cursor: "pointer",
                              padding: 0,
                            }} 
                            onClick={(e) => {
                              let r=false;
                              reportConfigs.map((config, index) => 
                                {
                                  if(config.sent_to_pacs){
                                    alert("Please unsend the config first"); // Add this for debugging
                                    r=true;
                                    return;
                                  }
                                }
                              )
                              if(r){
                                return;
                              }
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              const data = {
                                job_id: jobId,
                                config_name: config.config,
                              };
                              axios
                                .post(baseURLAPI + "/verify_config", data, {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                })
                                .then((res) => {
                                  console.log(res);
                                  setToastMessage("Config verified");
                                  setToastOpen(true);
                                  setToastAnchorEl(e.currentTarget);
                                  setTimeout(() => {
                                    setToastOpen(false);
                                  }, 2000);
                                  getConfigs(jobId);
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }}
                          />
                        </Tooltip>
                      )
                      :
                      (
                        <Tooltip title="Un-verify">
                          <VerifiedIcon
                            style={{
                              fill: "green",
                              cursor: "pointer",
                              padding: 0,
                            }}
                            onClick={(e) => {
                              if(config.sent_to_pacs){
                                alert("Please unsend the config first"); // Add this for debugging
                                return;
                              }
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              const data = {
                                job_id: jobId,
                                config_name: config.config,
                              };
                              axios
                                .post(baseURLAPI + "/unverify_config", data, {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                })
                                .then((res) => {
                                  console.log(res);
                                  setToastMessage("Config unverified");
                                  setToastOpen(true);
                                  setToastAnchorEl(e.currentTarget);
                                  setTimeout(() => {
                                    setToastOpen(false);
                                  }, 2000);
                                  getConfigs(jobId);
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                              }}
                          />
                        </Tooltip>
                      )
                      }
                      {!config.sent_to_pacs ? (
                        <Tooltip title="Send">
                          <SendIcon
                            style={{
                              fill: "#077F8E",
                              cursor: "pointer",
                              padding: 0,
                            }}
                            onClick={(e) => {
                              if(!config.verified){
                                alert("Please verify the config first"); // Add this for debugging
                                return;
                              }
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              const data = {
                                job_id: jobId,
                                config_name: config.config,
                              };
                              axios
                                .post(baseURLAPI + "/send_report", data, {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                })
                                .then((res) => {
                                  console.log(res);
                                  setToastMessage("Report sent");
                                  setToastOpen(true);
                                  setToastAnchorEl(e.currentTarget);
                                  setTimeout(() => {
                                    setToastOpen(false);
                                  }, 2000);
                                  getConfigs(jobId);
                                })
                                .then(() => {
                                  const formData1 = new FormData();
                                  formData1.append("job_id", jobId);
                                  formData1.append("update_key", "current_user");
                                  formData1.append("update_val", "");
                                  const token = admin
                                    ? localStorage.getItem(`token-${center}`)
                                    : localStorage.getItem("token");
                                  axios
                                    .post(`${baseURLAPI}/job_update`, formData1, {
                                      headers: {
                                        Authorization: `Bearer ${token}`,
                                      },
                                    })
                                    .then((res) => {
                                      console.log(res);
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                  const formData = new FormData();
                                  formData.append("job_id", jobId);
                                  formData.append("update_key", "on_verification");
                                  formData.append("update_val", false);
                                  axios
                                    .post(`${baseURLAPI}/job_update`, formData, {
                                      headers: {
                                        Authorization: `Bearer ${token}`,
                                      },
                                    })
                                    .then((res) => {
                                      console.log(res);
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Unsend">
                          <CancelScheduleSendIcon
                            style={{
                              fill: "#077F8E",
                              cursor: "pointer",
                              padding: 0,
                            }}
                            onClick={(e) => {
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              const data = {
                                job_id: jobId,
                                config_name: config.config,
                              };
                              axios
                                .post(baseURLAPI + "/unsend_report", data, {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                })
                                .then((res) => {
                                  console.log(res);
                                  setToastMessage("Report unsent");
                                  setToastOpen(true);
                                  setToastAnchorEl(e.currentTarget);
                                  setTimeout(() => {
                                    setToastOpen(false);
                                  }, 2000);
                                  getConfigs(jobId);
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }}
                          />
                      </Tooltip>
                      )}
                      {center == "ozone" &&
                        (!config.video_sent ? (
                          <WhatsAppIcon
                            style={{
                              fill: "#077F8E",
                              cursor: "pointer",
                              padding: 0,
                            }}
                            onClick={(e) => {
                              const token = admin
                                ? localStorage.getItem(`token-${center}`)
                                : localStorage.getItem("token");
                              const data = {
                                job_id: jobId,
                                config_name: config.config,
                              };
                              axios
                                .post(baseURLAPI + "/send_video_report", data, {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                })
                                .then((res) => {
                                  getConfigs(jobId);
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }}
                          />
                        ) : (
                          <MarkChatReadIcon />
                        ))}
                    </td>
                    <td style={styles.reportTableBodyItem}>
                      {config.sent_to_pacs ? (
                        <DoneIcon style={{ fill: "green", padding: 0 }} />
                      ) : (
                        <ClearIcon style={{ fill: "red", padding: 0 }} />
                      )}
                    </td>
                    <td style={styles.reportTableBodyItem}>
                      {config.config_time}
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </Modal>
          <Modal
          open={reportModalOpen}
          onClose={() => {
            setReportModalOpen(false);
          }}
          >
            <div style={mobile ? styles.reportModalMobile : styles.reportModal}>
              {
                typeof window !== "undefined" &&
                window.navigator &&
                window.navigator.mimeTypes &&
                window.navigator.mimeTypes["application/pdf"] ? (
                  <iframe
                    ref={pdfRef}
                    style={{ width: "100%", height: "100%" }}
                  />
                ) : pdfFile && !reportLoading ? (
                  <div
                    className="pdf-container"
                    style={{
                      width: "100%",
                      maxWidth: "800px",
                      maxHeight: "100%",
                      height: "100%",
                      overflowY: "scroll",
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Document
                      file={pdfFile}
                      loading={<CircularProgress />}
                      onLoadSuccess={({ numPages }) => {
                        setPdfNumPages(numPages);
                        setPdfIndex(1);
                      }}
                    >
                      <Page
                        pageNumber={pdfIndex}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        width={!mobile ? 780 : 370}
                        height={!mobile ? 400 : 400}
                      />
                    </Document>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <p>
                        Page {pdfIndex} of {pdfNumPages}
                      </p>
                      <IconButton
                        onClick={() => {
                          if (pdfIndex > 1) setPdfIndex(pdfIndex - 1);
                        }}
                      >
                        <ArrowBackIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          if (pdfIndex < pdfNumPages) setPdfIndex(pdfIndex + 1);
                        }}
                      >
                        <ArrowForwardIcon />
                      </IconButton>
                    </div>
                  </div>
                ) : (
                  <CircularProgress />
                )
              }
            </div>
          </Modal>

            {/* vivek */}
          <Modal open={reportModalOpen2} 
            onClose={() => {
                setReportModalOpen2(false);
              }}
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: "#000",
                color: "#fff",
                height: "85%",
                width: "50%",
                overflowY: "scroll",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zoom: "0.7",
                textAlign: "center",
              }}
              onContextMenu={(e) => e.preventDefault()}
            >
              {reportLoading ? (
                <div style={{ textAlign: "center", paddingTop: "20px" }}>
                  <CircularProgress />
                </div>
              ) : (
                images.map((src, index) => (
                  <img
                    key={index}
                    src={src}
                    alt={`Page ${index + 1}`}
                    style={{
                      maxWidth: "100%",
                      marginBottom: "20px",
                      display: "block",
                      userSelect: "none",
                    }}
                    draggable={false}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                ))
              )}
            </div>
          </Modal>

          <DropzoneDialogBase
            dialogTitle={DialogTitleMerge()}
            acceptedFiles={[".pdf"]}
            filesLimit={1}
            open={mergeModal}
            fileObjects={fileObjects}
            cancelButtonText={"cancel"}
            submitButtonText={"Merge"}
            Icon={NoteAdd}
            onAdd={(newFileObjs) => {
              console.log("onAdd", newFileObjs);
              console.log(newFileObjs[0].name);
              setFileObjects(newFileObjs);
            }}
            onDelete={(deleteFileObj) => {
              console.log("onDelete", deleteFileObj);
              setFileObjects([]);
            }}
            onClose={() => setMergeModal(false)}
            onSave={() => {
              const token = admin
                ? localStorage.getItem(`token-${center}`)
                : localStorage.getItem("token");
              console.log("onSave", fileObjects);
              const formData = new FormData();
              formData.append("job_id", jobId);
              formData.append("pdffile", fileObjects[0].data);
              // formData.append('update_val', 'yes');
              axios({
                method: "POST",
                url: `${baseURL}/merge_pdfs`,
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                data: formData,
                responseType: "arraybuffer",
              })
                .then((res) => {
                  let blob = new Blob([res.data], {
                    type: "application/pdf",
                  });
                  let url = window.URL.createObjectURL(blob);
                  let link = document.createElement("a");
                  link.href = url;
                  link.download = `${jobId}.pdf`;
                  link.click();
                  setMergeModal(false);
                })
                .catch((err) => {
                  console.log("error: ", err);
                });
            }}
            showPreviews={true}
            showFileNamesInPreview={true}
            showPreviewsInDropzone={false}
            dropzoneText={"Drag and drop or click here"}
            onChange={(files) => console.log("Files:", files)}
          />

          <Popper
            open={toastOpen}
            anchorEl={toastAnchorEl}
            placement={toastPlacement || "bottom"}
          >
            <div style={styles.popper}>{toastMessage}</div>
          </Popper>
          <Popper
            open={errorsOpen}
            anchorEl={toastAnchorEl}
            placement={toastPlacement || "bottom"}
          >
            <div style={styles.popper}>
              {toastMessage &&
                errorsOpen &&
                toastMessage.map((error, index) => (
                  <p
                    key={index}
                    style={{
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      color: "red",
                    }}
                  >
                    {error}
                  </p>
                ))}
            </div>
          </Popper>
          <Popper
            open={warningsOpen}
            anchorEl={toastAnchorEl}
            placement={toastPlacement || "bottom"}
          >
            <div style={styles.popper}>
              {/* {toastMessage.other &&
                toastMessage.other.map((warning, index) => (
                  <p
                    key={index}
                    style={{
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      color: "red",
                    }}
                  >
                    {warning}
                  </p>
                ))}
              <div
                style={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: "black",
                  margin: "5px 0px",
                }}
              ></div>
              {toastMessage.kub &&
                toastMessage.kub.map((warning, index) => (
                  <p
                    key={index}
                    style={{
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      color: "red",
                    }}
                  >
                    {warning}
                  </p>
                ))}
              <div
                style={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: "black",
                  margin: "5px 0px",
                }}
              ></div> */}
              {toastMessage.cac && toastMessage.cac.length > 0 ? (
                <p
                  style={{
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    color: "red",
                  }}
                >
                  {toastMessage.cac.length} cac(s) were filtered out.
                  Please check annotate viewer to see them.
                </p>
              ) : null}
            </div>
          </Popper>
        </div>
      </div>

      {mobile && 
        <div className="mobilePageNavigation">
        <Button
          variant="text"
          disabled={page <= 0}
          style={{
            color: page <= 0 ? "#888" : "#1b4b84",
          }}
          onClick={() => {
            console.log("previous page");
            if (page > 0) {
              setPage(page - 1);
              navigate(
                `/jobs?showAll=${showAll}&page=${
                  page - 1
                }&filterText=${filterText}`
              );
            }
          }}
        >
          <ArrowBackIcon />
        </Button>
        <span style={{ color: "black" }}>{parseInt(page) + 1}</span>
        <Button
          variant="text"
          disabled={jobs.length < 10}
          style={{
            color: jobs.length < 10 ? "#888" : "#1b4b84",
          }}
          onClick={() => {
            console.log("next page");
            setPage(page + 1);
            navigate(
              `/jobs?showAll=${showAll}&page=${
                page + 1
              }&filterText=${filterText}&startDate=${startDate}&endDate=${endDate}`
            );
          }}
        >
          <ArrowForwardIcon />
        </Button>
      </div>
      }
    </div>
  );
}
